// import React, { useState, useEffect } from 'react';
// import Header from '../../layouts/Header';
// import {
//     Col,
//     Row,
//     Card,
//     Table,
//     Button,
//     Form,
//     Modal,
//     Spinner,
//     Badge,
//     InputGroup,
//     FormControl
// } from 'react-bootstrap';
// import { useSelector } from 'react-redux';
// import Select from 'react-select';
// import axiosInstance from '../../api/axios';import { toast } from 'react-toastify';
// import {
//     Package,
//     Store,
//     Search,
//     Filter,
//     Edit,
//     Trash2,
//     Download,
//     RefreshCw,
//     ArrowLeft,
//     Plus,
//     X,
//     ChevronDown,
//     ChevronUp
// } from 'lucide-react';
// import makeAnimated from "react-select/animated";
// import { set } from 'date-fns';

// const NewArrivals = () => {
//     const currentSkin = localStorage.getItem("skin-mode") ? "dark" : "";
//     const [skin, setSkin] = useState(currentSkin);

//     const { access } = useSelector((state) => state.login);
//     const [newArrivalsAccess, setNewArrivalsAccess] = useState([]);
//     const animatedComponents = makeAnimated();

//     // Main states
//     const [loading, setLoading] = useState(false);
//     const [outlets, setOutlets] = useState([]);
//     const [products, setProducts] = useState([]);
//     const [newArrivals, setNewArrivals] = useState([]);
//     const [filteredNewArrivals, setFilteredNewArrivals] = useState([]);
//     const [selectedOutlet, setSelectedOutlet] = useState(null);
//     const [viewMode, setViewMode] = useState('list'); // 'list' or 'products'

//     // Filter states
//     const [statusFilter, setStatusFilter] = useState('ACTIVE'); // 'ACTIVE', 'INACTIVE', 'ALL'
//     const [searchQuery, setSearchQuery] = useState('');
//     const [searchOutletQuery, setSearchOutletQuery] = useState('');

//     // Modal states
//     const [showEditModal, setShowEditModal] = useState(false);
//     const [showDeleteModal, setShowDeleteModal] = useState(false);
//     const [showAddModal, setShowAddModal] = useState(false);
//     const [selectedProduct, setSelectedProduct] = useState(null);
//     const [selectedProductsForAdd, setSelectedProductsForAdd] = useState([]);
//     const [sequenceNumber, setSequenceNumber] = useState('');
//     const [editLoading, setEditLoading] = useState(false);
//     const [deleteLoading, setDeleteLoading] = useState(false);
//     const [addLoading, setAddLoading] = useState(false);

//     // Download state
//     const [downloadLoading, setDownloadLoading] = useState(false);

//     // Filter for add product modal
//     const [productSearch, setProductSearch] = useState('');
//     const [selectedProductType, setSelectedProductType] = useState('ALL');
//     const [selectedCategory, setSelectedCategory] = useState(null);
//     const [categoryList, setCategoryList] = useState([]);
//     const [productOptions, setProductOptions] = useState([]);
//     const [filteredProductOptions, setFilteredProductOptions] = useState([]);
//     const accessToken = localStorage.getItem('authToken');
//     const [selectedArrivalId, setSelectedArrivalId] = useState('');
//     // Custom styles for react-select
//     const customSelectStyles = {
//         control: (provided, state) => ({
//             ...provided,
//             width: "100%",
//             borderRadius: "6px",
//             minWidth: "200px",
//             borderColor: state.isFocused ? "#80bdff" : "#ced4da",
//             boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(0,123,255,.25)" : null,
//             "&:hover": {
//                 borderColor: state.isFocused ? "#80bdff" : "#ced4da"
//             }
//         }),
//         placeholder: (provided) => ({
//             ...provided,
//             color: "#6c757d"
//         })
//     };

//     const selectedProductValues = selectedProductsForAdd.map(p => ({
//         value: p._id,
//         label: p.name
//     }));


//     // Get permissions
//     useEffect(() => {
//         if (Array.isArray(access)) {
//             const filteredAccess = access?.filter((perm) =>
//                 perm?.startsWith("NewArrivals:")
//             );
//             setNewArrivalsAccess(filteredAccess);
//         }
//     }, [access]);

//     // Fetch all outlets
//     const getOutlets = async () => {
//         setLoading(true);
//         try {
//             const headers = { Authorization: `Bearer ${accessToken}` };
//             const response = await axiosInstance.get("outlet", { headers });

//             if (response?.data?.status === true) {
//                 const outletsData = response?.data?.data?.outlets || [];
//                 const outletOptions = outletsData.map(outlet => ({
//                     value: outlet._id,
//                     label: outlet.name || outlet.outletName || 'Unknown Outlet',
//                     status: outlet.status
//                 }));
//                 setOutlets(outletOptions);
//             }
//         } catch (error) {
//             showError(error, 'Failed to fetch outlets');
//         } finally {
//             setLoading(false);
//         }
//     };

//     // Fetch all products for add modal
//     const getAllProducts = async () => {
//         try {
//             const headers = { Authorization: `Bearer ${accessToken}` };
//             const response = await axiosInstance.get("product", { headers });

//             if (response?.data?.status === true) {
//                 const productsData = response?.data?.data?.products || [];
//                 let filterProductsData = productsData.filter(product => product.isFreebieProduct === false);

//                 setProducts(filterProductsData);

//                 // Prepare product options for react-select
//                 const options = filterProductsData.map(product => ({
//                     value: product._id,
//                     label: product.name,
//                     foodType: product.foodType,
//                     classType: product.classType,
//                     status: product.status,
//                     category: product.category
//                 }));
//                 setProductOptions(options);
//                 setFilteredProductOptions(options);
//             }
//         } catch (error) {
//             console.error('Error fetching products:', error);
//         }
//     };

//     // Fetch category list
//     const getCategoryList = async () => {
//         try {
//             const headers = { Authorization: `Bearer ${accessToken}` };
//             const response = await axiosInstance.get("masters/category/get", { headers });

//             if (response?.data?.status === true) {
//                 const categoriesData = response?.data?.data?.categories || [];
//                 const categoryOptions = categoriesData.map(category => ({
//                     value: category._id,
//                     label: category.name || category.categoryName || 'Unknown Category'
//                 }));
//                 setCategoryList(categoryOptions);
//             }
//         } catch (error) {
//             console.error('Error fetching categories:', error);
//         }
//     };

//     // Fetch new arrivals for selected outlet
//     const getNewArrivals = async (outletId = null) => {
//         const outletParam = outletId || selectedOutlet?.value;

//         if (!outletParam) {
//             toast.warning('Please select an outlet first', {
//                 position: "top-right",
//                 autoClose: 3000,
//             });
//             return;
//         }

//         setLoading(true);
//         try {
//             const headers = { Authorization: `Bearer ${accessToken}` };
//             const response = await axiosInstance.get(
//                 `outlet-wise-new-arrivals/admin?outlet=${outletParam}&page=1&limit=100`,
//                 { headers }
//             );

//             if (response?.data?.status === true) {
//                 const data = response?.data?.data?.outletWiseNewArrivals || [];
//                 setNewArrivals(data);
//                 applyFilters(data, statusFilter, searchQuery);
//             }
//         } catch (error) {
//             showError(error, 'Failed to fetch new arrivals');
//         } finally {
//             setLoading(false);
//         }
//     };

//     // Apply filters
//     const applyFilters = (arrivalsData, status, search) => {
//         let filtered = [...arrivalsData];

//         // Apply search filter
//         if (search.trim() !== '') {
//             const query = search.toLowerCase();
//             filtered = filtered.filter(item => {
//                 const productName = item?.product?.name || '';
//                 const productDesc = item?.product?.description || '';
//                 return productName.toLowerCase().includes(query) ||
//                     productDesc.toLowerCase().includes(query);
//             });
//         }

//         // Sort by sequence number
//         filtered.sort((a, b) => (a.sequenceNumber || 0) - (b.sequenceNumber || 0));

//         setFilteredNewArrivals(filtered);
//     };

//     // Filter products for add modal
//     const getFilteredProductOptions = (category) => {
//         let filtered = [...productOptions];

//         // Filter by search
//         if (productSearch.trim() !== '') {
//             const query = productSearch.toLowerCase();
//             filtered = filtered.filter(option =>
//                 option.label.toLowerCase().includes(query)
//             );
//         }

//         // Filter by type
//         if (selectedProductType !== 'ALL') {
//             filtered = filtered.filter(option =>
//                 option.classType === selectedProductType
//             );
//         }

//         // Filter by category
//         if (selectedCategory) {
//             filtered = filtered.filter(option =>
//                 option.category === selectedCategory.value
//             );
//         }

//         // Filter out already added products
//         const existingProductIds = newArrivals.map(item => item.product?._id);
//         filtered = filtered.filter(option =>
//             !existingProductIds.includes(option.value)
//         );

//         return filtered;
//     };

//     // Handle status filter change
//     const handleStatusFilterChange = (status) => {
//         setStatusFilter(status);
//         applyFilters(newArrivals, status, searchQuery);
//     };

//     // Handle search input change
//     const handleSearchChange = (e) => {
//         const value = e.target.value;
//         setSearchQuery(value);
//         applyFilters(newArrivals, statusFilter, value);
//     };

//     // Handle outlet search input change
//     const handleOutletSearchChange = (e) => {
//         const value = e.target.value;
//         setSearchOutletQuery(value);
//         applyFilters(newArrivals, statusFilter, value);
//     };

//     // Clear search
//     const clearSearch = () => {
//         setSearchQuery('');
//         applyFilters(newArrivals, statusFilter, '');
//     };

//     const clearOutletSearch = () => {
//         setSearchOutletQuery('');
//         applyFilters(newArrivals, statusFilter, '');
//     };

//     // Handle view products
//     const handleViewProducts = (outlet) => {
//         setSelectedOutlet({
//             value: outlet.value,
//             label: outlet.label,
//             status: outlet.status
//         });
//         setViewMode('products');
//         getNewArrivals(outlet.value);
//     };

//     // Handle back to list
//     const handleBackToList = () => {
//         setViewMode('list');
//         setSelectedOutlet(null);
//         setNewArrivals([]);
//         setFilteredNewArrivals([]);
//     };

//     // Handle edit sequence
//     const handleEditSequence = (product) => {
//         console.log("product details :", product);
//         setSelectedArrivalId(product?._id)
//         setSelectedProduct(product);
//         setSequenceNumber(product.sequenceNumber || '');
//         setShowEditModal(true);
//     };

//     const handleSubmitEdit = async (e) => {
//         e.preventDefault();
//         setEditLoading(true);

//         try {
//             const headers = { Authorization: `Bearer ${accessToken}` };
//             const data = {
//                 outlet: selectedOutlet?.value,
//                 product: selectedProduct?.product?._id,
//                 _id: selectedArrivalId,
//                 sequenceNumber: parseFloat(sequenceNumber)
//             };

//             const response = await axiosInstance.put('outlet-wise-new-arrivals', data, { headers });

//             if (response?.data?.status === true) {
//                 toast.success('Sequence updated successfully!', {
//                     position: "top-right",
//                     autoClose: 3000,
//                 });
//                 setShowEditModal(false);
//                 getNewArrivals();
//             }
//         } catch (error) {
//             showError(error, 'Failed to update sequence');
//         } finally {
//             setEditLoading(false);
//         }
//     };

//     // Handle delete
//     const handleDelete = (product) => {
//         setSelectedProduct(product);
//         setShowDeleteModal(true);
//     };

//     const handleSubmitDelete = async () => {
//         setDeleteLoading(true);

//         try {
//             const headers = { Authorization: `Bearer ${accessToken}` };
//             const data = {
//                 _id: selectedProduct._id
//             };

//             const response = await axiosInstance.delete('outlet-wise-new-arrivals', { data, headers });

//             if (response?.data?.status === true) {
//                 toast.success('Product removed from new arrivals!', {
//                     position: "top-right",
//                     autoClose: 3000,
//                 });
//                 setShowDeleteModal(false);
//                 getNewArrivals();
//             }
//         } catch (error) {
//             showError(error, 'Failed to remove product');
//         } finally {
//             setDeleteLoading(false);
//         }
//     };

//     // Handle add products
//     const handleAddProducts = () => {
//         setShowAddModal(true);

//     };

//     useEffect(() => {
//         getAllProducts();
//         getCategoryList();
//     }, []);

//     const handleProductSelect = (selectedOptions) => {
//         const selectedProducts = selectedOptions || [];

//         setSelectedProductsForAdd(prev => {
//             // Map selected options
//             const mappedProducts = selectedProducts.map(option => ({
//                 _id: option.value,
//                 name: option.label
//             }));

//             return mappedProducts
//         });
//     };

//     const handleUpdateSequence = (index, value) => {
//         const updatedProducts = [...selectedProductsForAdd];
//         updatedProducts[index].sequenceNumber = parseFloat(value) || 0;
//         setSelectedProductsForAdd(updatedProducts);
//     };

//     const handleRemoveSelectedProduct = (index) => {
//         const updatedProducts = selectedProductsForAdd.filter((_, i) => i !== index);
//         setSelectedProductsForAdd(updatedProducts);
//     };

//     // Remove product from react-select
//     const handleRemoveProductFromSelect = (productId) => {
//         setSelectedProductsForAdd(prev => {
//             const updated = prev.filter(p => p._id !== productId);
//             // Update sequence numbers
//             return updated.map((product, idx) => ({
//                 ...product,
//                 sequenceNumber: idx + 1
//             }));
//         });
//     };

//     const handleSubmitAdd = async (e) => {
//         e.preventDefault();
//         if (selectedProductsForAdd.length === 0) {
//             toast.warning('Please select at least one product', {
//                 position: "top-right",
//                 autoClose: 3000,
//             });
//             return;
//         }

//         setAddLoading(true);

//         try {
//             const headers = {
//                 Authorization: `Bearer ${accessToken}`,
//                 'Content-Type': 'application/json'
//             };

//             const data = {
//                 outlet: selectedOutlet?.value,
//                 productData: selectedProductsForAdd.map(product => ({
//                     product: product._id,
//                     sequenceNumber: product.sequenceNumber
//                 }))
//             };

//             const response = await axiosInstance.post('outlet-wise-new-arrivals', data, { headers });

//             if (response?.data?.status === true) {
//                 toast.success('Products added to new arrivals successfully!', {
//                     position: "top-right",
//                     autoClose: 3000,
//                 });
//                 setShowAddModal(false);
//                 setSelectedProductsForAdd([]);
//                 setProductSearch('');
//                 setSelectedProductType('ALL');
//                 setSelectedCategory(null);
//                 getNewArrivals();
//             }
//         } catch (error) {
//             showError(error, 'Failed to add products');
//         } finally {
//             setAddLoading(false);
//         }
//     };

//     // Download Excel
//     const handleDownloadExcel = async () => {
//         if (!selectedOutlet) {
//             toast.warning('Please select an outlet first', {
//                 position: "top-right",
//                 autoClose: 3000,
//             });
//             return;
//         }

//         setDownloadLoading(true);
//         try {
//             const headers = { Authorization: `Bearer ${accessToken}` };
            
//             // Build URL with isDownload flag
//             const url = `outlet-wise-new-arrivals/admin?outlet=${selectedOutlet.value}&isDownload=true`;
            
//             const response = await axiosInstance.get(url, { 
//                 headers,
//                 responseType: 'arraybuffer' // Use arraybuffer for better compatibility
//             });
            
//             // Check content type
//             const contentType = response.headers['content-type'] || '';
            
//             // If response is JSON (error case), parse it
//             if (contentType.includes('application/json')) {
//                 const decoder = new TextDecoder('utf-8');
//                 const text = decoder.decode(new Uint8Array(response.data));
//                 const errorData = JSON.parse(text);
//                 toast.error(errorData.error || errorData.message || "Failed to download file");
//                 setDownloadLoading(false);
//                 return;
//             }
            
//             // Generate standardized filename with timestamp
//             const date = new Date();
//             const timestamp = `${date.getFullYear()}${String(date.getMonth() + 1).padStart(2, '0')}${String(date.getDate()).padStart(2, '0')}_${String(date.getHours()).padStart(2, '0')}${String(date.getMinutes()).padStart(2, '0')}${String(date.getSeconds()).padStart(2, '0')}`;
            
//             // Create filename with outlet name
//             let filename = `New Arrivals`;
//             if (selectedOutlet.label) {
//                 filename += `In ${selectedOutlet.label.replace(/\s+/g, '_')}`;
//             }
            
//             // Determine file extension based on content type
//             if (contentType.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')) {
//                 filename += '.xlsx';
//             } else if (contentType.includes('application/vnd.ms-excel')) {
//                 filename += '.xls';
//             } else if (contentType.includes('text/csv') || contentType.includes('application/csv')) {
//                 filename += '.csv';
//             } else {
//                 // Default to xlsx
//                 filename += '.xlsx';
//             }
            
//             // Create blob with proper MIME type
//             const blob = new Blob([response.data], { 
//                 type: contentType || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
//             });
            
//             // Verify file is not empty
//             if (blob.size === 0) {
//                 toast.error("Downloaded file is empty");
//                 setDownloadLoading(false);
//                 return;
//             }
            
//             // Create download link
//             const downloadUrl = window.URL.createObjectURL(blob);
//             const link = document.createElement('a');
//             link.href = downloadUrl;
//             link.setAttribute('download', filename);
//             document.body.appendChild(link);
//             link.click();
            
//             // Cleanup
//             setTimeout(() => {
//                 document.body.removeChild(link);
//                 window.URL.revokeObjectURL(downloadUrl);
//             }, 200);
            
//             toast.success(`New arrivals for "${selectedOutlet.label}" downloaded successfully!`, {
//                 position: "top-right",
//                 autoClose: 3000,
//             });
//         } catch (error) {
//             console.error("Download error:", error);
            
//             // Handle error responses
//             if (error.response?.data instanceof ArrayBuffer || error.response?.data instanceof Uint8Array) {
//                 try {
//                     const decoder = new TextDecoder('utf-8');
//                     const text = decoder.decode(new Uint8Array(error.response.data));
//                     const errorData = JSON.parse(text);
//                     toast.error(errorData.error || errorData.message || "Failed to download file");
//                 } catch {
//                     toast.error("Failed to download file. The server returned an unexpected response.");
//                 }
//             } else {
//                 showError(error, 'Failed to download file');
//             }
//         } finally {
//             setDownloadLoading(false);
//         }
//     };

//     // Error handler
//     const showError = (error, defaultMessage) => {
//         const errorMessage = error.response?.data?.error || defaultMessage;
//         toast.error(errorMessage, {
//             position: "top-right",
//             autoClose: 3000,
//         });
//     };

//     // Format price
//     const formatPrice = (price) => {
//         return price ? `₹${parseFloat(price).toFixed(2)}` : 'N/A';
//     };

//     // Format date
//     const formatDate = (dateString) => {
//         try {
//             return new Date(dateString).toLocaleDateString('en-IN', {
//                 day: '2-digit',
//                 month: 'short',
//                 year: 'numeric'
//             });
//         } catch {
//             return dateString;
//         }
//     };

//     // Get status badge
//     const getStatusBadge = (status) => {
//         const variants = {
//             ACTIVE: 'success',
//             INACTIVE: 'danger',
//             COMING_SOON: 'warning'
//         };
//         return <Badge bg={variants[status] || 'secondary'}>{status}</Badge>;
//     };

//     // Get food type badge
//     const getFoodTypeBadge = (type) => {
//         const variants = {
//             VEG: 'success',
//             'NON_VEG': 'danger',
//             VEGAN: 'primary',
//             'VEG/VEGAN': 'info'
//         };
//         return <Badge bg={variants[type] || 'secondary'}>{type}</Badge>;
//     };

//     // Calculate discount
//     const getDiscount = (mrp, offer) => {
//         if (!mrp || !offer) return null;
//         const discount = ((mrp - offer) / mrp) * 100;
//         return Math.round(discount);
//     };

//     // Clear all filters in add modal
//     const clearAllFilters = () => {
//         setProductSearch('');
//         setSelectedProductType('ALL');
//         setSelectedCategory(null);
//     };

//     const handleCategoryChange = (option) => {
//         // Always update selected category (this fixes clear)
//         setSelectedCategory(option);

//         // Filter products only if category exists
//         if (option?.value) {
//             const filteredProducts = productOptions.filter(
//                 (product) => product?.category?._id === option.value
//             );
//             setFilteredProductOptions(filteredProducts);
//         } else {
//             // When cleared, reset product list
//             setFilteredProductOptions(productOptions);
//         }
//     };

//     const handleCloseAddModal = () => {
//         setShowAddModal(false);
//         setSelectedProductsForAdd([]);
//         setSelectedCategory('');
//     }


//     // Initialize
//     useEffect(() => {
//         getOutlets();
//     }, []);

//     return (
//         <>
//             <Header onSkin={setSkin} />

//             <div className="main main-app p-3 p-lg-4">
//                 <div className="container shadow-sm" style={{ backgroundColor: "white" }}>
//                     {/* Header */}
//                     <Row className="pt-3">
//                         <Col>
//                             <div className="d-flex align-items-center justify-content-between mb-2">
//                                 <div className="d-flex align-items-center">
//                                     <Package className="me-3" size={26} color="#0d6efd" />
//                                     <h4 className="fw-semibold mb-0">NEW ARRIVALS MANAGEMENT</h4>
//                                 </div>
//                                 {viewMode === 'products' && (
//                                     <Button
//                                         variant="outline-secondary"
//                                         onClick={handleBackToList}
//                                         size="sm"
//                                         style={{ width: '100px' }}
//                                     >
//                                         <ArrowLeft size={16} className="me-1" />
//                                         Back
//                                     </Button>
//                                 )}
//                                 {viewMode === 'list' && (
//                                     <Button
//                                         variant="outline-secondary"
//                                         onClick={handleBackToList}
//                                         size="sm"
//                                         className="invisible"
//                                     >
//                                         Back to Outlets
//                                     </Button>
//                                 )}
//                             </div>
//                         </Col>
//                         <hr />
//                     </Row>

//                     {viewMode === 'list' ? (
//                         /* Outlets List View */
//                         <>
//                             {/* Filters Section */}
//                             <Row className="mb-3">
//                                 <Col md={6} lg={6} className="mb-3">
//                                     <div className="d-flex align-items-center mb-2">
//                                         <Filter size={18} className="me-2 text-muted" />
//                                         <h6 className="mb-0">Status Filter</h6>
//                                     </div>
//                                     <div className="d-flex gap-2">
//                                         <Button
//                                             variant={statusFilter === 'ACTIVE' ? 'primary' : 'outline-primary'}
//                                             size="sm"
//                                             onClick={() => handleStatusFilterChange('ACTIVE')}
//                                             className="flex-fill"
//                                         >
//                                             Active
//                                         </Button>
//                                         <Button
//                                             variant={statusFilter === 'INACTIVE' ? 'danger' : 'outline-danger'}
//                                             size="sm"
//                                             onClick={() => handleStatusFilterChange('INACTIVE')}
//                                             className="flex-fill"
//                                         >
//                                             Inactive
//                                         </Button>
//                                         <Button
//                                             variant={statusFilter === 'COMING_SOON' ? 'warning' : 'outline-warning'}
//                                             size="sm"
//                                             onClick={() => handleStatusFilterChange('COMING_SOON')}
//                                             className="flex-fill"
//                                         >
//                                             Coming Soon
//                                         </Button>
//                                         <Button
//                                             variant={statusFilter === 'ALL' ? 'secondary' : 'outline-secondary'}
//                                             size="sm"
//                                             onClick={() => handleStatusFilterChange('ALL')}
//                                             className="flex-fill"
//                                         >
//                                             All
//                                         </Button>
//                                     </div>
//                                 </Col>
//                                 <Col md={6} lg={6} className="mb-3">
//                                     <div className="d-flex align-items-center mb-2">
//                                         <Search size={18} className="me-2 text-muted" />
//                                         <h6 className="mb-0">Search Outlet</h6>
//                                     </div>
//                                     <InputGroup>
//                                         <FormControl
//                                             placeholder="Search by outlet name..."
//                                             value={searchOutletQuery}
//                                             onChange={handleOutletSearchChange}
//                                         />
//                                         {searchOutletQuery && (
//                                             <Button variant="outline-secondary" onClick={clearOutletSearch}>
//                                                 Clear
//                                             </Button>
//                                         )}
//                                     </InputGroup>
//                                 </Col>
//                             </Row>

//                             {/* Outlets List */}
//                             <Row className="mb-4">
//                                 <Col>
//                                     <div className="d-flex justify-content-between align-items-center mb-3">
//                                         <h5 className="mb-0">OUTLETS</h5>
//                                         <Button
//                                             variant="outline-primary"
//                                             onClick={getOutlets}
//                                             disabled={loading}
//                                             className="w-25"
//                                             size="sm"
//                                         >
//                                             <RefreshCw size={16} className="me-2" />
//                                             {loading ? 'Refreshing...' : 'Refresh'}
//                                         </Button>
//                                     </div>

//                                     {loading ? (
//                                         <div className="text-center py-4">
//                                             <Spinner animation="border" variant="primary" />
//                                             <p className="mt-2 mb-0">Loading outlets...</p>
//                                         </div>
//                                     ) : outlets.length > 0 ? (
//                                         <Row>
//                                             {outlets
//                                                 .filter(outlet =>
//                                                     statusFilter === 'ALL' || outlet.status === statusFilter
//                                                 )
//                                                 .filter(outlet =>
//                                                     !searchOutletQuery ||
//                                                     outlet.label.toLowerCase().includes(searchOutletQuery.toLowerCase())
//                                                 )
//                                                 .map((outlet, index) => (
//                                                     <Col key={outlet.value} md={6} lg={4} className="mb-3">
//                                                         <Card className="h-100 shadow-sm">
//                                                             <Card.Body className="p-3">
//                                                                 <div className="d-flex justify-content-between align-items-start mb-3">
//                                                                     <div>
//                                                                         <div className="d-flex align-items-center mb-1">
//                                                                             <Store size={18} className="text-muted me-2" />
//                                                                             <h6 className="card-title mb-0 fw-semibold">
//                                                                                 {outlet.label}
//                                                                             </h6>
//                                                                         </div>
//                                                                         <p className="text-muted mb-0 small">
//                                                                             Click to view new arrivals
//                                                                         </p>
//                                                                     </div>
//                                                                     <Badge bg={outlet.status === 'ACTIVE' ? 'success' : outlet.status === 'COMING_SOON' ? 'warning' : 'danger'}>
//                                                                         {outlet.status}
//                                                                     </Badge>
//                                                                 </div>

//                                                                 <Button
//                                                                     variant="outline-primary"
//                                                                     size="sm"
//                                                                     onClick={() => handleViewProducts(outlet)}
//                                                                     className="w-100"
//                                                                 >
//                                                                     <Package size={16} className="me-1" />
//                                                                     View New Arrivals
//                                                                 </Button>
//                                                             </Card.Body>
//                                                         </Card>
//                                                     </Col>
//                                                 ))}
//                                         </Row>
//                                     ) : (
//                                         <div className="text-center py-4">
//                                             <p className="text-muted mb-0">
//                                                 No outlets found.
//                                             </p>
//                                         </div>
//                                     )}
//                                 </Col>
//                             </Row>
//                         </>
//                     ) : (
//                         /* Products View */
//                         <>
//                             {/* Outlet Info */}
//                             <Row className="mb-4">
//                                 <Col md={7}>
//                                     <Card>
//                                         <Card.Body>
//                                             <div className="d-flex align-items-center">
//                                                 <Store size={24} className="text-primary me-3" />
//                                                 <div>
//                                                     <h5 className="mb-1">Outlet: {selectedOutlet?.label}</h5>
//                                                     <div className="d-flex align-items-center">
//                                                         <Badge bg={selectedOutlet?.status === 'ACTIVE' ? 'success' : selectedOutlet?.status === 'COMING_SOON' ? 'warning' : 'danger'}>
//                                                             {selectedOutlet?.status || 'ACTIVE'}
//                                                         </Badge>
//                                                         <small className="text-muted ms-3">
//                                                             Showing new arrivals for this outlet
//                                                         </small>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         </Card.Body>
//                                     </Card>
//                                 </Col>
//                                 <Col md={5}>
//                                     <Card className={`${skin === 'dark' ? 'bg-dark' : 'bg-primary'} text-white`}>
//                                         <Card.Body>
//                                             <div className="d-flex justify-content-between align-items-center">
//                                                 <div>
//                                                     <h6 className="mb-1">Total Products</h6>
//                                                     <h3 className="mb-0">{filteredNewArrivals.length}</h3>
//                                                 </div>
//                                                 <Package size={36} />
//                                             </div>
//                                         </Card.Body>
//                                     </Card>
//                                 </Col>
//                             </Row>

//                             {/* Actions Section */}
//                             <Row className="mb-4">
//                                 <Col md={7}>
//                                     <InputGroup>
//                                         <InputGroup.Text>
//                                             <Search size={18} />
//                                         </InputGroup.Text>
//                                         <FormControl
//                                             placeholder="Search products by name"
//                                             value={searchQuery}
//                                             onChange={handleSearchChange}
//                                         />
//                                         {searchQuery && (
//                                             <Button variant="outline-secondary" onClick={clearSearch}>
//                                                 Clear
//                                             </Button>
//                                         )}
//                                     </InputGroup>
//                                 </Col>
//                                 <Col md={5}>
//                                     <div className="d-flex gap-2">
//                                         <Button
//                                             variant="primary"
//                                             onClick={handleAddProducts}
//                                             className="w-50"
//                                         >
//                                             <Plus size={16} className="me-2" />
//                                             Add Products
//                                         </Button>
//                                         <Button
//                                             variant="outline-success"
//                                             className="w-50"
//                                             disabled={downloadLoading || filteredNewArrivals.length === 0}
//                                             onClick={handleDownloadExcel}
//                                         >
//                                             {downloadLoading ? (
//                                                 <Spinner size="sm" animation="border" />
//                                             ) : (
//                                                 <Download size={16} className="me-2" />
//                                             )}
//                                             {downloadLoading ? " Downloading..." : " Download"}
//                                         </Button>
//                                     </div>
//                                 </Col>
//                             </Row>

//                             {/* Products Table */}
//                             <Row>
//                                 <Col>
//                                     <Card className='mb-3'>
//                                         <Card.Header className="d-flex justify-content-between align-items-center">
//                                             <h6 className="mb-0">New Arrivals - {selectedOutlet?.label}</h6>
//                                             <Button
//                                                 variant="outline-primary"
//                                                 size="sm"
//                                                 onClick={() => getNewArrivals()}
//                                                 disabled={loading}
//                                             >
//                                                 <RefreshCw size={16} className="me-1" />
//                                                 {loading ? 'Refreshing...' : 'Refresh'}
//                                             </Button>
//                                         </Card.Header>
//                                         <Card.Body>
//                                             {loading ? (
//                                                 <div className="text-center py-4">
//                                                     <Spinner animation="border" variant="primary" />
//                                                     <p className="mt-2 mb-0">Loading products...</p>
//                                                 </div>
//                                             ) : filteredNewArrivals.length > 0 ? (
//                                                 <div className="table-responsive">
//                                                     <Table striped bordered hover>
//                                                         <thead>
//                                                             <tr>
//                                                                 <th width="60">Sq No</th>
//                                                                 <th>Product Name</th>
//                                                                 <th>Type</th>
//                                                                 <th>Status</th>
//                                                                 <th>Added On</th>
//                                                                 <th>Actions</th>
//                                                             </tr>
//                                                         </thead>
//                                                         <tbody>
//                                                             {filteredNewArrivals.map((item, index) => {
//                                                                 const product = item.product || {};
//                                                                 const discount = getDiscount(product.mrp, product.offerPrice);

//                                                                 return (
//                                                                     <tr key={item._id}>
//                                                                         <td>
//                                                                             <Badge bg="primary" className="fs-6">
//                                                                                 {item.sequenceNumber || index + 1}
//                                                                             </Badge>
//                                                                         </td>
//                                                                         <td>
//                                                                             <div className="fw-semibold">{product.name}</div>
//                                                                             <small className='text-muted d-block'>
//                                                                                 {product.category?.name || 'Uncategorized'}
//                                                                             </small>
//                                                                         </td>
//                                                                         <td>
//                                                                             {getFoodTypeBadge(product.foodType)}
//                                                                             <div className="mt-1">
//                                                                                 <small className="text-muted">
//                                                                                     {product.classType}
//                                                                                 </small>
//                                                                             </div>
//                                                                         </td>
//                                                                         <td>{getStatusBadge(product.status)}</td>
//                                                                         <td>
//                                                                             <small className="text-muted">
//                                                                                 {formatDate(item.createdAt)}
//                                                                             </small>
//                                                                         </td>
//                                                                         <td>
//                                                                             <div className="d-flex gap-2">
//                                                                                 <Button
//                                                                                     variant="outline-primary"
//                                                                                     size="sm"
//                                                                                     onClick={() => handleEditSequence(item)}
//                                                                                     title="Edit Sequence"
//                                                                                 >
//                                                                                     <Edit size={14} />
//                                                                                 </Button>
//                                                                                 <Button
//                                                                                     variant="outline-danger"
//                                                                                     size="sm"
//                                                                                     onClick={() => handleDelete(item)}
//                                                                                     title="Remove"
//                                                                                 >
//                                                                                     <Trash2 size={14} />
//                                                                                 </Button>
//                                                                             </div>
//                                                                         </td>
//                                                                     </tr>
//                                                                 );
//                                                             })}
//                                                         </tbody>
//                                                     </Table>
//                                                 </div>
//                                             ) : (
//                                                 <div className="text-center py-4">
//                                                     <Package size={48} className="text-muted mb-3" />
//                                                     <h5>No New Arrivals Found</h5>
//                                                     <p className="text-muted mb-3">
//                                                         {newArrivals.length === 0
//                                                             ? "No new arrivals found for this outlet."
//                                                             : "No products match your search."}
//                                                     </p>
//                                                 </div>
//                                             )}
//                                         </Card.Body>
//                                     </Card>
//                                 </Col>
//                             </Row>
//                         </>
//                     )}
//                 </div>

//                 {/* Edit Sequence Modal */}
//                 <Modal show={showEditModal} onHide={() => setShowEditModal(false)} centered>
//                     <Modal.Header closeButton>
//                         <Modal.Title>
//                             <Edit size={20} className="me-2" />
//                             Edit Sequence Number
//                         </Modal.Title>
//                     </Modal.Header>
//                     <Form onSubmit={handleSubmitEdit}>
//                         <Modal.Body>
//                             <Form.Group className="mb-3">
//                                 <Form.Label>Product Name</Form.Label>
//                                 <Form.Control
//                                     type="text"
//                                     value={selectedProduct?.product?.name || ''}
//                                     readOnly
//                                     className="bg-light"
//                                 />
//                             </Form.Group>
//                             <Form.Group>
//                                 <Form.Label>Sequence Number</Form.Label>
//                                 <Form.Control
//                                     type="number"
//                                     value={sequenceNumber}
//                                     onChange={(e) => setSequenceNumber(e.target.value)}
//                                     placeholder="Enter sequence number"
//                                     min="0.01"
//                                     step="0.01"
//                                     required
//                                 />
//                             </Form.Group>
//                         </Modal.Body>
//                         <Modal.Footer>
//                             <Button
//                                 variant="secondary"
//                                 onClick={() => setShowEditModal(false)}
//                                 disabled={editLoading}
//                             >
//                                 Cancel
//                             </Button>
//                             <Button
//                                 variant="primary"
//                                 type="submit"
//                                 disabled={editLoading}
//                             >
//                                 {editLoading ? (
//                                     <>
//                                         <Spinner
//                                             as="span"
//                                             animation="border"
//                                             size="sm"
//                                             role="status"
//                                             aria-hidden="true"
//                                             className="me-2"
//                                         />
//                                         Updating...
//                                     </>
//                                 ) : (
//                                     'Update Sequence'
//                                 )}
//                             </Button>
//                         </Modal.Footer>
//                     </Form>
//                 </Modal>

//                 {/* Delete Confirmation Modal */}
//                 <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
//                     <Modal.Header closeButton>
//                         <Modal.Title>Confirm Delete</Modal.Title>
//                     </Modal.Header>
//                     <Modal.Body>
//                         <p>Are you sure you want to remove this product from new arrivals?</p>
//                         <div className="alert alert-warning">
//                             <strong>Product:</strong> {selectedProduct?.product?.name}<br />
//                             <strong>Outlet:</strong> {selectedOutlet?.label}
//                         </div>
//                         <p className="text-muted small">
//                             This will only remove the product from new arrivals. The product will remain in your catalog.
//                         </p>
//                     </Modal.Body>
//                     <Modal.Footer>
//                         <Button
//                             variant="secondary"
//                             onClick={() => setShowDeleteModal(false)}
//                             disabled={deleteLoading}
//                         >
//                             Cancel
//                         </Button>
//                         <Button
//                             variant="danger"
//                             onClick={handleSubmitDelete}
//                             disabled={deleteLoading}
//                         >
//                             {deleteLoading ? (
//                                 <>
//                                     <Spinner
//                                         as="span"
//                                         animation="border"
//                                         size="sm"
//                                         role="status"
//                                         aria-hidden="true"
//                                         className="me-2"
//                                     />
//                                     Deleting...
//                                 </>
//                             ) : (
//                                 "Delete Product"
//                             )}
//                         </Button>
//                     </Modal.Footer>
//                 </Modal>

//                 {/* Add Products Modal */}
//                 <Modal show={showAddModal} onHide={handleCloseAddModal} size="lg">
//                     <Modal.Header closeButton>
//                         <Modal.Title>
//                             <Plus size={20} className="me-2" />
//                             Add Products to New Arrivals
//                         </Modal.Title>
//                     </Modal.Header>
//                     <Form onSubmit={handleSubmitAdd}>
//                         <Modal.Body >
//                             {/* Product Selection */}
//                             <Row className="mb-4">
//                                 <Col md={4}>
//                                     <Form.Group>
//                                         <Form.Label className="fw-semibold">Category</Form.Label>
//                                         <Select
//                                             options={categoryList}
//                                             value={selectedCategory}
//                                             onChange={handleCategoryChange}
//                                             components={animatedComponents}
//                                             placeholder="Select category..."
//                                             isClearable
//                                             styles={customSelectStyles}
//                                         />
//                                     </Form.Group>
//                                 </Col>
//                                 <Col>
//                                     <Form.Group>
//                                         <Form.Label className="fw-semibold">
//                                             Select Products ({selectedProductsForAdd.length} selected)
//                                         </Form.Label>
//                                         <Select
//                                             options={filteredProductOptions}
//                                             value={selectedProductValues}
//                                             onChange={handleProductSelect}
//                                             placeholder="Search and select products..."
//                                             isMulti
//                                             isSearchable
//                                             isClearable
//                                             styles={customSelectStyles}
//                                             closeMenuOnSelect={false}
//                                             filterOption={(option, input) => {
//                                                 if (!input) return true;
//                                                 return option.label.toLowerCase().includes(input.toLowerCase());
//                                             }}
//                                             noOptionsMessage={({ inputValue }) =>
//                                                 inputValue
//                                                     ? `No products found matching "${inputValue}"`
//                                                     : "No products available"
//                                             }
//                                         />
//                                     </Form.Group>
//                                 </Col>
//                             </Row>

//                             {/* Selected Products Table */}
//                             {selectedProductsForAdd.length > 0 && (
//                                 <Card className="mb-4">
//                                     <Card.Header className="d-flex justify-content-between align-items-center">
//                                         <h6 className="mb-0">Selected Products ({selectedProductsForAdd?.length})</h6>
//                                         <Button
//                                             variant="outline-danger"
//                                             size="sm"
//                                             onClick={() => setSelectedProductsForAdd([])}
//                                         >
//                                             Clear All
//                                         </Button>
//                                     </Card.Header>
//                                     <Card.Body>
//                                         <div className="table-responsive">
//                                             <Table striped hover size="sm">
//                                                 <thead>
//                                                     <tr>
//                                                         <th width="50">Sq No</th>
//                                                         <th>Product Name</th>
//                                                         <th width="150">Sequence</th>
//                                                         <th width="80">Action</th>
//                                                     </tr>
//                                                 </thead>
//                                                 <tbody>
//                                                     {selectedProductsForAdd.map((product, index) => (
//                                                         <tr key={product._id}>
//                                                             <td className="align-middle">
//                                                                 <Badge bg="primary">{index + 1}</Badge>
//                                                             </td>
//                                                             <td className="align-middle">
//                                                                 <div className="fw-semibold">{product.name}</div>
//                                                             </td>
//                                                             <td className="align-middle">
//                                                                 <Form.Control
//                                                                     type="number"
//                                                                     value={product.sequenceNumber}
//                                                                     onChange={(e) => handleUpdateSequence(index, e.target.value)}
//                                                                     min="0.01"
//                                                                     step="0.01"
//                                                                     size="sm"
//                                                                 />
//                                                             </td>
//                                                             <td className="align-middle">
//                                                                 <Button
//                                                                     variant="outline-danger"
//                                                                     size="sm"
//                                                                     onClick={() => handleRemoveSelectedProduct(index)}
//                                                                     title="Remove"
//                                                                 >
//                                                                     <X size={14} />
//                                                                 </Button>
//                                                             </td>
//                                                         </tr>
//                                                     ))}
//                                                 </tbody>
//                                             </Table>
//                                         </div>
//                                     </Card.Body>
//                                 </Card>
//                             )}
//                         </Modal.Body>
//                         <Modal.Footer>
//                             <Button
//                                 variant="secondary"
//                                 onClick={() => {
//                                     setShowAddModal(false);
//                                     setSelectedProductsForAdd([]);
//                                     clearAllFilters();
//                                 }}
//                                 disabled={addLoading}
//                             >
//                                 Cancel
//                             </Button>
//                             <Button
//                                 variant="primary"
//                                 type="submit"
//                                 disabled={addLoading || selectedProductsForAdd.length === 0}
//                             >
//                                 {addLoading ? (
//                                     <>
//                                         <Spinner
//                                             as="span"
//                                             animation="border"
//                                             size="sm"
//                                             role="status"
//                                             aria-hidden="true"
//                                             className="me-2"
//                                         />
//                                         Adding...
//                                     </>
//                                 ) : (
//                                     `Add ${selectedProductsForAdd.length} Product${selectedProductsForAdd.length !== 1 ? 's' : ''}`
//                                 )}
//                             </Button>
//                         </Modal.Footer>
//                     </Form>
//                 </Modal>
//             </div>
//         </>
//     );
// };

// export default NewArrivals;



import React, { useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import Header from '../../layouts/Header';
import { Button, Form, Modal, Spinner } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import axiosInstance from '../../api/axios';
import { toast } from 'react-toastify';
import {
    Package,
    Store,
    Search,
    Edit,
    Trash2,
    Download,
    RefreshCw,
    ArrowLeft,
    Plus,
    X,
    MapPin,
    ChevronLeft,
    ChevronRight,
    MoreVertical,
    Calendar,
    Layers
} from 'lucide-react';
import makeAnimated from "react-select/animated";

const PAGE_SIZE_OPTIONS = [12, 24, 48];

const STATUS_META = {
    ACTIVE: { label: 'Active', cls: 'is-active' },
    INACTIVE: { label: 'Inactive', cls: 'is-inactive' },
    COMING_SOON: { label: 'Coming Soon', cls: 'is-soon' },
};

const FOOD_TYPE_META = {
    VEG: { label: 'Veg', cls: 'is-veg' },
    NON_VEG: { label: 'Non-Veg', cls: 'is-nonveg' },
    VEGAN: { label: 'Vegan', cls: 'is-vegan' },
    'VEG/VEGAN': { label: 'Veg / Vegan', cls: 'is-vegan' },
};

// Local YYYY-MM-DD (avoids the UTC shift that toISOString() causes).
const toISODate = (d) => {
    if (!d) return '';
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};

const initialOf = (name) => (name || '?').trim().charAt(0).toUpperCase() || '?';

const StatusPill = ({ status }) => {
    const meta = STATUS_META[status] || { label: status || '—', cls: 'is-other' };
    return <span className={`na-pill ${meta.cls}`}>{meta.label}</span>;
};

// Outlet photo (API field: outletImage) with a lettered fallback.
const Thumb = ({ src, name, size = 64 }) => {
    const [broken, setBroken] = useState(false);
    useEffect(() => { setBroken(false); }, [src]);
    return (
        <div className="na-thumb" style={{ width: size, height: size }}>
            {src && !broken ? (
                <img src={src} alt="" onError={() => setBroken(true)} />
            ) : (
                <span style={{ fontSize: size * 0.4 }}>{initialOf(name)}</span>
            )}
        </div>
    );
};

// Card action menu. Rendered in a portal with fixed coordinates measured at
// click time, so it always opens right next to its own button — on the very
// first click too — and is never clipped by a parent's overflow.
const KebabMenu = ({ items }) => {
    const visible = items.filter(Boolean);
    const btnRef = useRef(null);
    const menuRef = useRef(null);
    const [pos, setPos] = useState(null);
    const MENU_W = 190;

    const close = useCallback(() => setPos(null), []);

    const open = () => {
        const r = btnRef.current?.getBoundingClientRect();
        if (!r) return;
        const estH = visible.length * 36 + 8;
        const flipUp = window.innerHeight - r.bottom < estH + 12 && r.top > estH + 12;
        setPos({
            top: flipUp ? r.top - estH - 4 : r.bottom + 4,
            left: Math.max(8, Math.min(r.right - MENU_W, window.innerWidth - MENU_W - 8)),
        });
    };

    useLayoutEffect(() => {
        if (!pos || !menuRef.current || !btnRef.current) return;
        const m = menuRef.current.getBoundingClientRect();
        const r = btnRef.current.getBoundingClientRect();
        if (m.bottom > window.innerHeight - 8) {
            const top = Math.max(8, r.top - m.height - 4);
            if (top !== pos.top) setPos((p) => (p ? { ...p, top } : p));
        }
    }, [pos]);

    useEffect(() => {
        if (!pos) return undefined;
        const onDown = (e) => {
            if (menuRef.current?.contains(e.target) || btnRef.current?.contains(e.target)) return;
            close();
        };
        const onKey = (e) => { if (e.key === 'Escape') close(); };
        window.addEventListener('mousedown', onDown);
        window.addEventListener('keydown', onKey);
        window.addEventListener('resize', close);
        window.addEventListener('scroll', close, true);
        return () => {
            window.removeEventListener('mousedown', onDown);
            window.removeEventListener('keydown', onKey);
            window.removeEventListener('resize', close);
            window.removeEventListener('scroll', close, true);
        };
    }, [pos, close]);

    if (!visible.length) return null;

    return (
        <>
            <button
                type="button" ref={btnRef} className="na-kebab" aria-label="More actions"
                aria-haspopup="menu" aria-expanded={!!pos}
                onClick={(e) => { e.stopPropagation(); if (pos) close(); else open(); }}
            >
                <MoreVertical size={16} />
            </button>
            {pos && createPortal(
                <div ref={menuRef} role="menu" className="na-kmenu" style={{ top: pos.top, left: pos.left, width: MENU_W }}>
                    {visible.map((it) => (
                        <button
                            key={it.label} type="button" role="menuitem"
                            className={`na-kitem ${it.danger ? 'is-danger' : ''}`}
                            onClick={() => { close(); it.onClick?.(); }}
                        >
                            {it.icon}{it.label}
                        </button>
                    ))}
                </div>,
                document.body
            )}
        </>
    );
};

// 1 … 4 5 6 … 20 style page list.
const buildPageList = (current, total) => {
    if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
    const set = new Set([1, total, current - 1, current, current + 1]);
    const list = [...set].filter((p) => p >= 1 && p <= total).sort((a, b) => a - b);
    const out = [];
    list.forEach((p, i) => {
        if (i > 0 && p - list[i - 1] > 1) out.push('…');
        out.push(p);
    });
    return out;
};

// Maps an outlet from the `outlet` API onto the shape this page uses.
const mapOutlet = (outlet) => {
    const city = outlet?.city || outlet?.address?.city || '';
    const state = outlet?.state || outlet?.address?.state || '';
    const addressText = typeof outlet?.address === 'string' ? outlet.address : '';
    return {
        value: outlet._id,
        label: outlet.name || outlet.outletName || 'Unknown Outlet',
        status: outlet.status,
        image: outlet.outletImage || '',
        location: [city, state].filter(Boolean).join(', ') || addressText,
        type: outlet.outletType || outlet.type || '',
    };
};

const selectStyles = {
    control: (provided, state) => ({
        ...provided,
        minHeight: 40,
        height: 40,
        fontSize: 13,
        borderRadius: 8,
        borderColor: state.isFocused ? '#3a57e8' : '#d0d5dd',
        boxShadow: state.isFocused ? '0 0 0 3px rgba(58,87,232,.15)' : 'none',
        '&:hover': { borderColor: state.isFocused ? '#3a57e8' : '#98a2b3' },
    }),
    valueContainer: (provided) => ({ ...provided, padding: '0 10px' }),
    indicatorSeparator: () => ({ display: 'none' }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    option: (provided, state) => ({
        ...provided,
        fontSize: 13,
        cursor: 'pointer',
        backgroundColor: state.isSelected ? '#3a57e8' : state.isFocused ? '#eef2ff' : '#fff',
        color: state.isSelected ? '#fff' : '#1d2939',
    }),
};

// Same look, but lets the control grow for multi-select.
const selectStylesMulti = {
    ...selectStyles,
    control: (provided, state) => ({ ...selectStyles.control(provided, state), height: 'auto', minHeight: 40 }),
    multiValue: (base) => ({ ...base, backgroundColor: '#eef2ff', borderRadius: 6 }),
    multiValueLabel: (base) => ({ ...base, color: '#3a57e8', fontWeight: 600, fontSize: 12.5 }),
    multiValueRemove: (base) => ({ ...base, color: '#3a57e8', ':hover': { backgroundColor: '#dbe3ff', color: '#2441c9' } }),
};

const selectCommon = {
    menuPortalTarget: typeof document !== 'undefined' ? document.body : undefined,
    menuPosition: 'fixed',
};

const NewArrivals = () => {
    const currentSkin = localStorage.getItem("skin-mode") ? "dark" : "";
    const [skin, setSkin] = useState(currentSkin);

    const { access } = useSelector((state) => state.login);
    const [newArrivalsAccess, setNewArrivalsAccess] = useState([]);
    const animatedComponents = makeAnimated();

    // Main states
    const [loading, setLoading] = useState(false);
    const [outlets, setOutlets] = useState([]);
    const [products, setProducts] = useState([]);
    const [newArrivals, setNewArrivals] = useState([]);
    const [selectedOutlet, setSelectedOutlet] = useState(null);
    const [viewMode, setViewMode] = useState('list'); // 'list' or 'products'

    // Outlet-list filters
    const [statusFilter, setStatusFilter] = useState('ALL'); // 'ALL' | 'ACTIVE' | 'INACTIVE' | 'COMING_SOON'
    const [outletFilter, setOutletFilter] = useState('ALL');
    const [typeFilter, setTypeFilter] = useState('ALL');
    const [searchOutletQuery, setSearchOutletQuery] = useState('');
    const [outletPage, setOutletPage] = useState(1);
    const [outletPageSize, setOutletPageSize] = useState(PAGE_SIZE_OPTIONS[0]);

    // Products-view filters
    const [searchQuery, setSearchQuery] = useState('');
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);

    // "New arrivals" count per outlet card. undefined = not requested yet,
    // null = loading, number = loaded, '—' = failed.
    const [arrivalCounts, setArrivalCounts] = useState({});
    const countRequested = useRef(new Set());

    // Modal states
    const [showEditModal, setShowEditModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showAddModal, setShowAddModal] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [selectedProductsForAdd, setSelectedProductsForAdd] = useState([]);
    const [sequenceNumber, setSequenceNumber] = useState('');
    const [editLoading, setEditLoading] = useState(false);
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [addLoading, setAddLoading] = useState(false);

    // Outlet chosen inside the Add modal when it is opened from the outlet list
    const [addOutlet, setAddOutlet] = useState(null);
    const [addExisting, setAddExisting] = useState([]); // [{ id, seq }] already added for addOutlet

    // Download state
    const [downloadLoading, setDownloadLoading] = useState(false);

    // Filter for add product modal
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [categoryList, setCategoryList] = useState([]);
    const [productOptions, setProductOptions] = useState([]);
    const accessToken = localStorage.getItem('authToken');
    const [selectedArrivalId, setSelectedArrivalId] = useState('');

    const authHeaders = { Authorization: `Bearer ${accessToken}` };

    // Get permissions
    useEffect(() => {
        if (Array.isArray(access)) {
            const filteredAccess = access?.filter((perm) =>
                perm?.startsWith("NewArrivals:")
            );
            setNewArrivalsAccess(filteredAccess);
        }
    }, [access]);

    // Error handler
    const showError = (error, defaultMessage) => {
        const errorMessage = error.response?.data?.error || defaultMessage;
        toast.error(errorMessage, {
            position: "top-right",
            autoClose: 3000,
        });
    };

    // Fetch all outlets
    const getOutlets = async () => {
        setLoading(true);
        try {
            const response = await axiosInstance.get("outlet", { headers: authHeaders });

            if (response?.data?.status === true) {
                const outletsData = response?.data?.data?.outlets || [];
                setOutlets(outletsData.map(mapOutlet));
            }
        } catch (error) {
            showError(error, 'Failed to fetch outlets');
        } finally {
            setLoading(false);
        }
    };

    // Fetch all products for add modal
    const getAllProducts = async () => {
        try {
            const response = await axiosInstance.get("product", { headers: authHeaders });

            if (response?.data?.status === true) {
                const productsData = response?.data?.data?.products || [];
                let filterProductsData = productsData.filter(product => product.isFreebieProduct === false);

                setProducts(filterProductsData);

                // Prepare product options for react-select
                const options = filterProductsData.map(product => ({
                    value: product._id,
                    label: product.name,
                    foodType: product.foodType,
                    classType: product.classType,
                    status: product.status,
                    category: product.category
                }));
                setProductOptions(options);
            }
        } catch (error) {
            console.error('Error fetching products:', error);
        }
    };

    // Fetch category list
    const getCategoryList = async () => {
        try {
            const response = await axiosInstance.get("masters/category/get", { headers: authHeaders });

            if (response?.data?.status === true) {
                const categoriesData = response?.data?.data?.categories || [];
                const categoryOptions = categoriesData.map(category => ({
                    value: category._id,
                    label: category.name || category.categoryName || 'Unknown Category'
                }));
                setCategoryList(categoryOptions);
            }
        } catch (error) {
            console.error('Error fetching categories:', error);
        }
    };

    // Fetch new arrivals for selected outlet
    const getNewArrivals = async (outletId = null) => {
        const outletParam = outletId || selectedOutlet?.value;

        if (!outletParam) {
            toast.warning('Please select an outlet first', {
                position: "top-right",
                autoClose: 3000,
            });
            return;
        }

        setLoading(true);
        try {
            const response = await axiosInstance.get(
                `outlet-wise-new-arrivals/admin?outlet=${outletParam}&page=1&limit=100`,
                { headers: authHeaders }
            );

            if (response?.data?.status === true) {
                const data = response?.data?.data?.outletWiseNewArrivals || [];
                setNewArrivals(data);
                setArrivalCounts((prev) => ({ ...prev, [outletParam]: data.length }));
            }
        } catch (error) {
            showError(error, 'Failed to fetch new arrivals');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getAllProducts();
        getCategoryList();
        getOutlets();
    }, []);

    // ─── Derived: outlet list ───────────────────────────────────────────────
    const outletTypeOptions = useMemo(() => {
        const types = [...new Set(outlets.map((o) => o.type).filter(Boolean))];
        return types.sort().map((t) => ({ value: t, label: t }));
    }, [outlets]);

    const outletSelectOptions = useMemo(
        () => [{ value: 'ALL', label: 'All Outlets' }, ...outlets.map((o) => ({ value: o.value, label: o.label }))],
        [outlets]
    );

    const filteredOutlets = useMemo(() => {
        const q = searchOutletQuery.trim().toLowerCase();
        return outlets.filter((o) => {
            if (statusFilter !== 'ALL' && o.status !== statusFilter) return false;
            if (outletFilter !== 'ALL' && o.value !== outletFilter) return false;
            if (typeFilter !== 'ALL' && o.type !== typeFilter) return false;
            if (q && !`${o.label} ${o.location}`.toLowerCase().includes(q)) return false;
            return true;
        });
    }, [outlets, statusFilter, outletFilter, typeFilter, searchOutletQuery]);

    const totalOutletPages = Math.max(1, Math.ceil(filteredOutlets.length / outletPageSize));
    const safeOutletPage = Math.min(outletPage, totalOutletPages);
    const pagedOutlets = useMemo(() => {
        const start = (safeOutletPage - 1) * outletPageSize;
        return filteredOutlets.slice(start, start + outletPageSize);
    }, [filteredOutlets, safeOutletPage, outletPageSize]);

    useEffect(() => { setOutletPage(1); }, [statusFilter, outletFilter, typeFilter, searchOutletQuery, outletPageSize]);

    const outletStats = useMemo(() => ({
        total: outlets.length,
        active: outlets.filter((o) => o.status === 'ACTIVE').length,
        soon: outlets.filter((o) => o.status === 'COMING_SOON').length,
        inactive: outlets.filter((o) => o.status === 'INACTIVE').length,
    }), [outlets]);

    // Lazily load "new arrivals" counts for the outlet cards on screen only
    // (3 requests at a time), instead of one request per outlet up front.
    useEffect(() => {
        if (viewMode !== 'list') return;
        const ids = pagedOutlets.map((o) => o.value).filter((id) => !countRequested.current.has(id));
        if (!ids.length) return;
        ids.forEach((id) => countRequested.current.add(id));
        setArrivalCounts((prev) => {
            const next = { ...prev };
            ids.forEach((id) => { next[id] = null; });
            return next;
        });

        const queue = [...ids];
        const worker = async () => {
            while (queue.length) {
                const id = queue.shift();
                try {
                    const response = await axiosInstance.get(
                        `outlet-wise-new-arrivals/admin?outlet=${id}&page=1&limit=100`,
                        { headers: { Authorization: `Bearer ${accessToken}` } }
                    );
                    const count = (response?.data?.data?.outletWiseNewArrivals || []).length;
                    setArrivalCounts((prev) => ({ ...prev, [id]: count }));
                } catch (error) {
                    countRequested.current.delete(id);
                    setArrivalCounts((prev) => ({ ...prev, [id]: '—' }));
                }
            }
        };
        Promise.all([worker(), worker(), worker()]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pagedOutlets, viewMode]);

    const resetOutletFilters = () => {
        setStatusFilter('ALL');
        setOutletFilter('ALL');
        setTypeFilter('ALL');
        setSearchOutletQuery('');
    };
    const outletFiltersActive = statusFilter !== 'ALL' || outletFilter !== 'ALL' || typeFilter !== 'ALL' || !!searchOutletQuery.trim();

    // ─── Derived: products view ─────────────────────────────────────────────
    const filteredNewArrivals = useMemo(() => {
        let filtered = [...newArrivals];
        const q = searchQuery.trim().toLowerCase();
        if (q) {
            filtered = filtered.filter((item) => {
                const productName = item?.product?.name || '';
                const productDesc = item?.product?.description || '';
                return productName.toLowerCase().includes(q) || productDesc.toLowerCase().includes(q);
            });
        }
        if (startDate || endDate) {
            const from = startDate ? toISODate(startDate) : '';
            const to = endDate ? toISODate(endDate) : '';
            filtered = filtered.filter((item) => {
                if (!item?.createdAt) return false;
                const d = toISODate(new Date(item.createdAt));
                return (!from || d >= from) && (!to || d <= to);
            });
        }
        filtered.sort((a, b) => (a.sequenceNumber || 0) - (b.sequenceNumber || 0));
        return filtered;
    }, [newArrivals, searchQuery, startDate, endDate]);

    // Handle view products
    const handleViewProducts = (outlet) => {
        setSelectedOutlet(outlet);
        setViewMode('products');
        setSearchQuery('');
        setStartDate(null);
        setEndDate(null);
        getNewArrivals(outlet.value);
    };

    // Handle back to list
    const handleBackToList = () => {
        setViewMode('list');
        setSelectedOutlet(null);
        setNewArrivals([]);
    };

    // Handle edit sequence
    const handleEditSequence = (product) => {
        setSelectedArrivalId(product?._id)
        setSelectedProduct(product);
        setSequenceNumber(product.sequenceNumber || '');
        setShowEditModal(true);
    };

    const handleSubmitEdit = async (e) => {
        e.preventDefault();
        setEditLoading(true);

        try {
            const data = {
                outlet: selectedOutlet?.value,
                product: selectedProduct?.product?._id,
                _id: selectedArrivalId,
                sequenceNumber: parseFloat(sequenceNumber)
            };

            const response = await axiosInstance.put('outlet-wise-new-arrivals', data, { headers: authHeaders });

            if (response?.data?.status === true) {
                toast.success('Sequence updated successfully!', {
                    position: "top-right",
                    autoClose: 3000,
                });
                setShowEditModal(false);
                getNewArrivals();
            }
        } catch (error) {
            showError(error, 'Failed to update sequence');
        } finally {
            setEditLoading(false);
        }
    };

    // Handle delete
    const handleDelete = (product) => {
        setSelectedProduct(product);
        setShowDeleteModal(true);
    };

    const handleSubmitDelete = async () => {
        setDeleteLoading(true);

        try {
            const data = {
                _id: selectedProduct._id
            };

            const response = await axiosInstance.delete('outlet-wise-new-arrivals', { data, headers: authHeaders });

            if (response?.data?.status === true) {
                toast.success('Product removed from new arrivals!', {
                    position: "top-right",
                    autoClose: 3000,
                });
                setShowDeleteModal(false);
                getNewArrivals();
            }
        } catch (error) {
            showError(error, 'Failed to remove product');
        } finally {
            setDeleteLoading(false);
        }
    };

    // ─── Add products ───────────────────────────────────────────────────────
    // Opened from the products view -> outlet is already known. Opened from the
    // outlet list (banner button or a card's menu) -> the modal asks for it.
    const handleAddProducts = (outlet = null) => {
        setAddOutlet(outlet);
        setShowAddModal(true);
    };

    const addTargetOutlet = viewMode === 'products' ? selectedOutlet : addOutlet;

    // When the Add modal is opened from the list, load that outlet's existing
    // arrivals so already-added products are hidden and sequence numbers
    // continue after the last one.
    useEffect(() => {
        if (!showAddModal || viewMode !== 'list' || !addOutlet?.value) {
            setAddExisting([]);
            return undefined;
        }
        let cancelled = false;
        (async () => {
            try {
                const response = await axiosInstance.get(
                    `outlet-wise-new-arrivals/admin?outlet=${addOutlet.value}&page=1&limit=100`,
                    { headers: { Authorization: `Bearer ${accessToken}` } }
                );
                if (cancelled) return;
                const list = response?.data?.data?.outletWiseNewArrivals || [];
                setAddExisting(list.map((i) => ({ id: i?.product?._id, seq: Number(i?.sequenceNumber) || 0 })));
            } catch (error) {
                if (!cancelled) setAddExisting([]);
            }
        })();
        return () => { cancelled = true; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showAddModal, viewMode, addOutlet?.value]);

    const existingArrivals = useMemo(
        () => (viewMode === 'products'
            ? newArrivals.map((i) => ({ id: i?.product?._id, seq: Number(i?.sequenceNumber) || 0 }))
            : addExisting),
        [viewMode, newArrivals, addExisting]
    );

    // Products that can still be added: matches the chosen category and is not
    // already in this outlet's new arrivals.
    const addableOptions = useMemo(() => {
        const existingIds = new Set(existingArrivals.map((e) => e.id));
        return productOptions.filter((option) => {
            if (existingIds.has(option.value)) return false;
            if (selectedCategory?.value) {
                const catId = option.category?._id || option.category;
                if (String(catId) !== String(selectedCategory.value)) return false;
            }
            return true;
        });
    }, [productOptions, existingArrivals, selectedCategory]);

    const selectedProductValues = selectedProductsForAdd.map(p => ({
        value: p._id,
        label: p.name
    }));

    const handleProductSelect = (selectedOptions) => {
        const picked = selectedOptions || [];
        setSelectedProductsForAdd((prev) => {
            const prevMap = new Map(prev.map((p) => [p._id, p]));
            // New picks continue the sequence after the outlet's last arrival
            // (or the highest number already entered in this form).
            let nextSeq = Math.max(0, ...existingArrivals.map((e) => e.seq), ...prev.map((p) => Number(p.sequenceNumber) || 0));
            return picked.map((option) => {
                const existing = prevMap.get(option.value);
                if (existing) return existing;
                nextSeq += 1;
                return { _id: option.value, name: option.label, sequenceNumber: nextSeq };
            });
        });
    };

    const handleUpdateSequence = (index, value) => {
        const updatedProducts = [...selectedProductsForAdd];
        updatedProducts[index] = { ...updatedProducts[index], sequenceNumber: value === '' ? '' : parseFloat(value) };
        setSelectedProductsForAdd(updatedProducts);
    };

    const handleRemoveSelectedProduct = (index) => {
        const updatedProducts = selectedProductsForAdd.filter((_, i) => i !== index);
        setSelectedProductsForAdd(updatedProducts);
    };

    const handleCloseAddModal = () => {
        if (addLoading) return;
        setShowAddModal(false);
        setSelectedProductsForAdd([]);
        setSelectedCategory(null);
        setAddOutlet(null);
    };

    const handleSubmitAdd = async (e) => {
        e.preventDefault();
        if (!addTargetOutlet?.value) {
            toast.warning('Please select an outlet', { position: "top-right", autoClose: 3000 });
            return;
        }
        if (selectedProductsForAdd.length === 0) {
            toast.warning('Please select at least one product', {
                position: "top-right",
                autoClose: 3000,
            });
            return;
        }
        if (selectedProductsForAdd.some((p) => !(Number(p.sequenceNumber) > 0))) {
            toast.warning('Every product needs a sequence number greater than 0', { position: "top-right", autoClose: 3000 });
            return;
        }

        setAddLoading(true);

        try {
            const headers = {
                ...authHeaders,
                'Content-Type': 'application/json'
            };

            const data = {
                outlet: addTargetOutlet.value,
                productData: selectedProductsForAdd.map(product => ({
                    product: product._id,
                    sequenceNumber: Number(product.sequenceNumber)
                }))
            };

            const response = await axiosInstance.post('outlet-wise-new-arrivals', data, { headers });

            if (response?.data?.status === true) {
                toast.success('Products added to new arrivals successfully!', {
                    position: "top-right",
                    autoClose: 3000,
                });
                const target = addTargetOutlet;
                setShowAddModal(false);
                setSelectedProductsForAdd([]);
                setSelectedCategory(null);
                setAddOutlet(null);
                if (viewMode === 'list') {
                    // Take the admin straight to the outlet they just updated.
                    handleViewProducts(target);
                } else {
                    getNewArrivals();
                }
            }
        } catch (error) {
            showError(error, 'Failed to add products');
        } finally {
            setAddLoading(false);
        }
    };

    // Download Excel
    const handleDownloadExcel = async () => {
        if (!selectedOutlet) {
            toast.warning('Please select an outlet first', {
                position: "top-right",
                autoClose: 3000,
            });
            return;
        }

        setDownloadLoading(true);
        try {
            const headers = { Authorization: `Bearer ${accessToken}` };

            // Build URL with isDownload flag
            const url = `outlet-wise-new-arrivals/admin?outlet=${selectedOutlet.value}&isDownload=true`;

            const response = await axiosInstance.get(url, {
                headers,
                responseType: 'arraybuffer' // Use arraybuffer for better compatibility
            });

            // Check content type
            const contentType = response.headers['content-type'] || '';

            // If response is JSON (error case), parse it
            if (contentType.includes('application/json')) {
                const decoder = new TextDecoder('utf-8');
                const text = decoder.decode(new Uint8Array(response.data));
                const errorData = JSON.parse(text);
                toast.error(errorData.error || errorData.message || "Failed to download file");
                setDownloadLoading(false);
                return;
            }

            // Create filename with outlet name
            let filename = `New Arrivals`;
            if (selectedOutlet.label) {
                filename += `In ${selectedOutlet.label.replace(/\s+/g, '_')}`;
            }

            // Determine file extension based on content type
            if (contentType.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')) {
                filename += '.xlsx';
            } else if (contentType.includes('application/vnd.ms-excel')) {
                filename += '.xls';
            } else if (contentType.includes('text/csv') || contentType.includes('application/csv')) {
                filename += '.csv';
            } else {
                // Default to xlsx
                filename += '.xlsx';
            }

            // Create blob with proper MIME type
            const blob = new Blob([response.data], {
                type: contentType || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });

            // Verify file is not empty
            if (blob.size === 0) {
                toast.error("Downloaded file is empty");
                setDownloadLoading(false);
                return;
            }

            // Create download link
            const downloadUrl = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();

            // Cleanup
            setTimeout(() => {
                document.body.removeChild(link);
                window.URL.revokeObjectURL(downloadUrl);
            }, 200);

            toast.success(`New arrivals for "${selectedOutlet.label}" downloaded successfully!`, {
                position: "top-right",
                autoClose: 3000,
            });
        } catch (error) {
            console.error("Download error:", error);

            // Handle error responses
            if (error.response?.data instanceof ArrayBuffer || error.response?.data instanceof Uint8Array) {
                try {
                    const decoder = new TextDecoder('utf-8');
                    const text = decoder.decode(new Uint8Array(error.response.data));
                    const errorData = JSON.parse(text);
                    toast.error(errorData.error || errorData.message || "Failed to download file");
                } catch {
                    toast.error("Failed to download file. The server returned an unexpected response.");
                }
            } else {
                showError(error, 'Failed to download file');
            }
        } finally {
            setDownloadLoading(false);
        }
    };

    // Format date
    const formatDate = (dateString) => {
        try {
            return new Date(dateString).toLocaleDateString('en-IN', {
                day: '2-digit',
                month: 'short',
                year: 'numeric'
            });
        } catch {
            return dateString;
        }
    };

    const rangeStart = filteredOutlets.length === 0 ? 0 : (safeOutletPage - 1) * outletPageSize + 1;
    const rangeEnd = Math.min(safeOutletPage * outletPageSize, filteredOutlets.length);

    const kpis = [
        { key: 'ALL', label: 'Total Outlets', value: outletStats.total, icon: <Store size={20} />, tone: 'blue' },
        { key: 'ACTIVE', label: 'Active', value: outletStats.active, icon: <Store size={20} />, tone: 'green' },
        { key: 'COMING_SOON', label: 'Coming Soon', value: outletStats.soon, icon: <Store size={20} />, tone: 'orange' },
        { key: 'INACTIVE', label: 'Inactive', value: outletStats.inactive, icon: <Store size={20} />, tone: 'red' },
    ];

    const statusOptions = [
        { value: 'ALL', label: 'All Status' },
        { value: 'ACTIVE', label: 'Active' },
        { value: 'INACTIVE', label: 'Inactive' },
        { value: 'COMING_SOON', label: 'Coming Soon' },
    ];
    const typeOptionsAll = [{ value: 'ALL', label: 'All Types' }, ...outletTypeOptions];
    const findOpt = (options, value) => options.find((o) => o.value === value) || options[0];

    const renderOutletCard = (outlet) => {
        const count = arrivalCounts[outlet.value];
        return (
            <div key={outlet.value} className="na-card">
                <div className="na-card-top">
                    <Thumb src={outlet.image} name={outlet.label} />
                    <div className="na-card-info">
                        <div className="na-card-row">
                            <div className="na-card-name" title={outlet.label}>{outlet.label}</div>
                            <StatusPill status={outlet.status} />
                            <KebabMenu
                                items={[
                                    { label: 'View New Arrivals', icon: <Package size={14} />, onClick: () => handleViewProducts(outlet) },
                                    { label: 'Add Products', icon: <Plus size={14} />, onClick: () => handleAddProducts(outlet) },
                                ]}
                            />
                        </div>
                        <div className="na-card-loc">
                            <MapPin size={13} />
                            <span>{outlet.location || 'No location added'}</span>
                        </div>
                    </div>
                </div>

                <div className="na-card-stats">
                    {outlet.type && (
                        <div className="na-stat">
                            <Layers size={14} />
                            <div>
                                <div className="na-stat-label">Type</div>
                                <div className="na-stat-value">{outlet.type}</div>
                            </div>
                        </div>
                    )}
                    <div className="na-stat">
                        <Package size={14} />
                        <div>
                            <div className="na-stat-label">New Arrivals</div>
                            <div className="na-stat-value">
                                {count === undefined || count === null ? <span className="na-dots">···</span> : count}
                            </div>
                        </div>
                    </div>
                </div>

                <button type="button" className="na-card-btn" onClick={() => handleViewProducts(outlet)}>
                    View details <ChevronRight size={14} />
                </button>
            </div>
        );
    };

    return (
        <>
            <Header onSkin={setSkin} />
            <style>{naStyles}</style>

            <div className="main main-app na-page">

                {/* ── Banner ── */}
                <div className="na-banner">
                    <div className="na-banner-left">
                        <div className="na-banner-icon"><Package size={26} /></div>
                        <div>
                            <div className="na-eyebrow">New Arrivals Management</div>
                            <h4 className="na-title">New Arrivals</h4>
                            <p className="na-subtitle">
                                {viewMode === 'list'
                                    ? 'Manage and track new arrivals across your outlets.'
                                    : `Showing new arrivals for ${selectedOutlet?.label || 'this outlet'}.`}
                            </p>
                        </div>
                    </div>
                    <div className="na-banner-art" aria-hidden="true">
                        <div className="na-art-plate"><span /><span /><span /></div>
                    </div>
                    <div className="na-banner-actions">
                        {viewMode === 'products' && (
                            <Button className="na-btn na-btn-ghost" onClick={handleBackToList}>
                                <ArrowLeft size={15} /> Back
                            </Button>
                        )}
                        <Button className="na-btn na-btn-primary" onClick={() => handleAddProducts(viewMode === 'products' ? selectedOutlet : null)}>
                            <Plus size={15} /> Add New Arrival
                        </Button>
                    </div>
                </div>

                {viewMode === 'list' ? (
                    <>
                        {/* ── Filters ── */}
                        <div className="na-panel na-filters">
                            <div className="na-search">
                                <Search size={15} />
                                <input
                                    type="text"
                                    placeholder="Search by outlet name..."
                                    value={searchOutletQuery}
                                    onChange={(e) => setSearchOutletQuery(e.target.value)}
                                    aria-label="Search outlets"
                                />
                                {searchOutletQuery && (
                                    <button type="button" aria-label="Clear search" onClick={() => setSearchOutletQuery('')}><X size={13} /></button>
                                )}
                            </div>
                            <div className="na-fsel">
                                <Select
                                    {...selectCommon}
                                    styles={selectStyles}
                                    options={statusOptions}
                                    value={findOpt(statusOptions, statusFilter)}
                                    onChange={(opt) => setStatusFilter(opt?.value || 'ALL')}
                                    isSearchable={false}
                                    aria-label="Status"
                                />
                            </div>
                            <div className="na-fsel">
                                <Select
                                    {...selectCommon}
                                    styles={selectStyles}
                                    options={outletSelectOptions}
                                    value={findOpt(outletSelectOptions, outletFilter)}
                                    onChange={(opt) => setOutletFilter(opt?.value || 'ALL')}
                                    aria-label="Outlet"
                                />
                            </div>
                            {outletTypeOptions.length > 0 && (
                                <div className="na-fsel">
                                    <Select
                                        {...selectCommon}
                                        styles={selectStyles}
                                        options={typeOptionsAll}
                                        value={findOpt(typeOptionsAll, typeFilter)}
                                        onChange={(opt) => setTypeFilter(opt?.value || 'ALL')}
                                        isSearchable={false}
                                        aria-label="Type"
                                    />
                                </div>
                            )}
                            <Button className="na-btn na-btn-soft" onClick={resetOutletFilters} disabled={!outletFiltersActive}>
                                <X size={14} /> Clear
                            </Button>
                            <Button className="na-btn na-btn-soft" onClick={getOutlets} disabled={loading} title="Refresh outlets">
                                <RefreshCw size={14} className={loading ? 'na-spin' : ''} /> Refresh
                            </Button>
                        </div>

                        {/* ── KPI cards (click to filter by status) ── */}
                        <div className="na-kpis">
                            {kpis.map((k) => (
                                <button
                                    key={k.key}
                                    type="button"
                                    className={`na-kpi tone-${k.tone} ${statusFilter === k.key ? 'is-active' : ''}`}
                                    onClick={() => setStatusFilter(k.key)}
                                >
                                    <div className="na-kpi-icon">{k.icon}</div>
                                    <div>
                                        <div className="na-kpi-value">{k.value}</div>
                                        <div className="na-kpi-label">{k.label}</div>
                                    </div>
                                </button>
                            ))}
                        </div>

                        {/* ── Outlet cards ── */}
                        <div className="na-panel na-grid-panel">
                            {loading && outlets.length === 0 ? (
                                <div className="text-center py-5">
                                    <Spinner animation="border" size="sm" />
                                    <p className="mt-2 mb-0 na-muted">Loading outlets...</p>
                                </div>
                            ) : filteredOutlets.length === 0 ? (
                                <div className="na-empty">
                                    <div className="na-empty-icon"><Store size={24} /></div>
                                    <div>No outlets found.</div>
                                    {outletFiltersActive && (
                                        <button type="button" className="na-linkbtn" onClick={resetOutletFilters}>Clear filters</button>
                                    )}
                                </div>
                            ) : (
                                <div className="na-grid">{pagedOutlets.map(renderOutletCard)}</div>
                            )}

                            <div className="na-pagination">
                                <span className="na-pagination-info">
                                    Showing {rangeStart} to {rangeEnd} of {filteredOutlets.length} outlet{filteredOutlets.length === 1 ? '' : 's'}
                                </span>
                                <div className="na-pagination-controls">
                                    <button type="button" className="na-pg" aria-label="Previous page" disabled={safeOutletPage <= 1} onClick={() => setOutletPage((p) => Math.max(1, p - 1))}>
                                        <ChevronLeft size={15} />
                                    </button>
                                    {buildPageList(safeOutletPage, totalOutletPages).map((p, i) => (
                                        p === '…' ? (
                                            <span key={`gap-${i}`} className="na-pg-gap">…</span>
                                        ) : (
                                            <button key={p} type="button" className={`na-pg ${p === safeOutletPage ? 'is-on' : ''}`} onClick={() => setOutletPage(p)}>{p}</button>
                                        )
                                    ))}
                                    <button type="button" className="na-pg" aria-label="Next page" disabled={safeOutletPage >= totalOutletPages} onClick={() => setOutletPage((p) => Math.min(totalOutletPages, p + 1))}>
                                        <ChevronRight size={15} />
                                    </button>
                                    <Form.Select className="na-pagesize" value={outletPageSize} onChange={(e) => setOutletPageSize(Number(e.target.value))} aria-label="Outlets per page">
                                        {PAGE_SIZE_OPTIONS.map((n) => (<option key={n} value={n}>{n} / page</option>))}
                                    </Form.Select>
                                </div>
                            </div>
                        </div>
                    </>
                ) : (
                    <>
                        {/* ── Outlet header ── */}
                        <div className="na-panel na-outlet-head">
                            <Thumb src={selectedOutlet?.image} name={selectedOutlet?.label} size={64} />
                            <div className="na-outlet-head-info">
                                <div className="na-card-row">
                                    <h5 className="na-outlet-name">{selectedOutlet?.label}</h5>
                                    <StatusPill status={selectedOutlet?.status || 'ACTIVE'} />
                                </div>
                                {selectedOutlet?.location && (
                                    <div className="na-card-loc"><MapPin size={13} /><span>{selectedOutlet.location}</span></div>
                                )}
                            </div>
                            <div className="na-total">
                                <div className="na-total-value">{filteredNewArrivals.length}</div>
                                <div className="na-total-label">Total Products</div>
                            </div>
                        </div>

                        {/* ── Actions ── */}
                        <div className="na-panel na-filters">
                            <div className="na-search na-search-wide">
                                <Search size={15} />
                                <input
                                    type="text"
                                    placeholder="Search products by name"
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                    aria-label="Search products"
                                />
                                {searchQuery && (
                                    <button type="button" aria-label="Clear search" onClick={() => setSearchQuery('')}><X size={13} /></button>
                                )}
                            </div>
                            <div className="na-date-wrap">
                                <Calendar size={14} className="na-date-icon" />
                                <DatePicker
                                    className="na-date-input"
                                    selectsRange
                                    startDate={startDate}
                                    endDate={endDate}
                                    onChange={(update) => {
                                        const [start, end] = update;
                                        setStartDate(start);
                                        setEndDate(end);
                                    }}
                                    dateFormat="dd MMM yyyy"
                                    placeholderText="Added on (date range)"
                                    popperPlacement="bottom-start"
                                />
                                {(startDate || endDate) && (
                                    <button type="button" className="na-date-clear" aria-label="Clear dates" onClick={() => { setStartDate(null); setEndDate(null); }}>
                                        <X size={12} />
                                    </button>
                                )}
                            </div>
                            <Button className="na-btn na-btn-soft" onClick={() => getNewArrivals()} disabled={loading}>
                                <RefreshCw size={14} className={loading ? 'na-spin' : ''} /> Refresh
                            </Button>
                            <Button
                                className="na-btn na-btn-success"
                                disabled={downloadLoading || filteredNewArrivals.length === 0}
                                onClick={handleDownloadExcel}
                            >
                                {downloadLoading ? <Spinner size="sm" animation="border" /> : <Download size={14} />}
                                {downloadLoading ? 'Downloading...' : 'Download'}
                            </Button>
                        </div>

                        {/* ── Products table ── */}
                        <div className="na-panel na-table-panel">
                            {loading && newArrivals.length === 0 ? (
                                <div className="text-center py-5">
                                    <Spinner animation="border" size="sm" />
                                    <p className="mt-2 mb-0 na-muted">Loading products...</p>
                                </div>
                            ) : filteredNewArrivals.length > 0 ? (
                                <div className={`na-tablewrap ${loading ? 'is-loading' : ''}`}>
                                    <table className="na-table">
                                        <thead>
                                            <tr>
                                                <th style={{ width: 80 }}>Sq No</th>
                                                <th>Product Name</th>
                                                <th>Type</th>
                                                <th>Status</th>
                                                <th>Added On</th>
                                                <th className="text-end">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredNewArrivals.map((item, index) => {
                                                const product = item.product || {};
                                                const foodMeta = FOOD_TYPE_META[product.foodType];
                                                return (
                                                    <tr key={item._id}>
                                                        <td><span className="na-seq">{item.sequenceNumber || index + 1}</span></td>
                                                        <td>
                                                            <div className="na-prod-name">{product.name}</div>
                                                            <div className="na-sub">{product.category?.name || 'Uncategorized'}</div>
                                                        </td>
                                                        <td>
                                                            {foodMeta
                                                                ? <span className={`na-food ${foodMeta.cls}`}>{foodMeta.label}</span>
                                                                : <span className="na-food">{product.foodType || '—'}</span>}
                                                            {product.classType && <div className="na-sub mt-1">{product.classType}</div>}
                                                        </td>
                                                        <td><StatusPill status={product.status} /></td>
                                                        <td className="na-muted">{formatDate(item.createdAt)}</td>
                                                        <td className="text-end">
                                                            <div className="na-ibtns">
                                                                <button type="button" className="na-ibtn" onClick={() => handleEditSequence(item)} title="Edit Sequence" aria-label="Edit sequence">
                                                                    <Edit size={15} />
                                                                </button>
                                                                <button type="button" className="na-ibtn is-danger" onClick={() => handleDelete(item)} title="Remove" aria-label="Remove">
                                                                    <Trash2 size={15} />
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            ) : (
                                <div className="na-empty">
                                    <div className="na-empty-icon"><Package size={24} /></div>
                                    <div className="na-empty-title">No New Arrivals Found</div>
                                    <div className="na-muted mb-2">
                                        {newArrivals.length === 0
                                            ? "No new arrivals found for this outlet."
                                            : "No products match your filters."}
                                    </div>
                                    {newArrivals.length === 0 && (
                                        <Button className="na-btn na-btn-primary" onClick={() => handleAddProducts(selectedOutlet)}>
                                            <Plus size={14} /> Add Products
                                        </Button>
                                    )}
                                </div>
                            )}
                        </div>
                    </>
                )}

                {/* Edit Sequence Modal */}
                <Modal show={showEditModal} onHide={() => setShowEditModal(false)} centered className="na-modal">
                    <Form onSubmit={handleSubmitEdit}>
                        <Modal.Header closeButton>
                            <div className="na-mh-icon"><Edit size={18} /></div>
                            <div>
                                <Modal.Title className="na-modal-title">Edit Sequence Number</Modal.Title>
                                <div className="na-modal-sub">Lower numbers appear first in the app.</div>
                            </div>
                        </Modal.Header>
                        <Modal.Body>
                            <Form.Group className="mb-3">
                                <Form.Label className="na-label">Product Name</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={selectedProduct?.product?.name || ''}
                                    readOnly
                                    className="na-input bg-light"
                                />
                            </Form.Group>
                            <Form.Group>
                                <Form.Label className="na-label">Sequence Number <span className="na-req">*</span></Form.Label>
                                <Form.Control
                                    type="number"
                                    className="na-input"
                                    value={sequenceNumber}
                                    onChange={(e) => setSequenceNumber(e.target.value)}
                                    placeholder="Enter sequence number"
                                    min="0.01"
                                    step="0.01"
                                    required
                                    autoFocus
                                />
                            </Form.Group>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button className="na-btn na-btn-soft" onClick={() => setShowEditModal(false)} disabled={editLoading}>
                                Cancel
                            </Button>
                            <Button className="na-btn na-btn-primary" type="submit" disabled={editLoading}>
                                {editLoading ? (
                                    <>
                                        <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                                        Updating...
                                    </>
                                ) : (
                                    'Update Sequence'
                                )}
                            </Button>
                        </Modal.Footer>
                    </Form>
                </Modal>

                {/* Delete Confirmation Modal */}
                <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered size="sm" className="na-modal">
                    <Modal.Body className="text-center na-del-body">
                        <div className="na-del-icon"><Trash2 size={20} /></div>
                        <div className="na-modal-title mb-1">Remove from new arrivals?</div>
                        <div className="na-del-box">
                            <div><strong>Product:</strong> {selectedProduct?.product?.name}</div>
                            <div><strong>Outlet:</strong> {selectedOutlet?.label}</div>
                        </div>
                        <p className="na-del-text">
                            This only removes the product from new arrivals. It stays in your catalog.
                        </p>
                        <div className="d-flex gap-2 justify-content-center">
                            <Button className="na-btn na-btn-soft" onClick={() => setShowDeleteModal(false)} disabled={deleteLoading}>
                                Cancel
                            </Button>
                            <Button className="na-btn na-btn-danger" onClick={handleSubmitDelete} disabled={deleteLoading}>
                                {deleteLoading ? (
                                    <>
                                        <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                                        Deleting...
                                    </>
                                ) : (
                                    "Delete Product"
                                )}
                            </Button>
                        </div>
                    </Modal.Body>
                </Modal>

                {/* Add Products Modal */}
                <Modal show={showAddModal} onHide={handleCloseAddModal} size="lg" centered backdrop="static" className="na-modal">
                    <Form onSubmit={handleSubmitAdd}>
                        <Modal.Header closeButton>
                            <div className="na-mh-icon"><Plus size={18} /></div>
                            <div>
                                <Modal.Title className="na-modal-title">Add Products to New Arrivals</Modal.Title>
                                <div className="na-modal-sub">
                                    {addTargetOutlet?.label ? `For ${addTargetOutlet.label}` : 'Pick an outlet, then the products to feature.'}
                                </div>
                            </div>
                        </Modal.Header>
                        <Modal.Body>
                            {viewMode === 'list' && (
                                <div className="mb-3">
                                    <Form.Label className="na-label">Outlet <span className="na-req">*</span></Form.Label>
                                    <Select
                                        {...selectCommon}
                                        styles={selectStyles}
                                        options={outlets.map((o) => ({ ...o }))}
                                        value={addOutlet}
                                        onChange={(opt) => { setAddOutlet(opt); setSelectedProductsForAdd([]); }}
                                        placeholder="Select outlet..."
                                        isSearchable
                                        autoFocus
                                    />
                                </div>
                            )}

                            <div className="na-add-grid">
                                <div>
                                    <Form.Label className="na-label">Category</Form.Label>
                                    <Select
                                        {...selectCommon}
                                        options={categoryList}
                                        value={selectedCategory}
                                        onChange={setSelectedCategory}
                                        components={animatedComponents}
                                        placeholder="All categories"
                                        isClearable
                                        styles={selectStyles}
                                    />
                                </div>
                                <div>
                                    <Form.Label className="na-label">
                                        Select Products ({selectedProductsForAdd.length} selected)
                                    </Form.Label>
                                    <Select
                                        {...selectCommon}
                                        options={addableOptions}
                                        value={selectedProductValues}
                                        onChange={handleProductSelect}
                                        placeholder={viewMode === 'list' && !addOutlet ? 'Select an outlet first' : 'Search and select products...'}
                                        isDisabled={viewMode === 'list' && !addOutlet}
                                        isMulti
                                        isSearchable
                                        isClearable
                                        styles={selectStylesMulti}
                                        closeMenuOnSelect={false}
                                        filterOption={(option, input) => {
                                            if (!input) return true;
                                            return option.label.toLowerCase().includes(input.toLowerCase());
                                        }}
                                        noOptionsMessage={({ inputValue }) =>
                                            inputValue
                                                ? `No products found matching "${inputValue}"`
                                                : "No more products to add"
                                        }
                                    />
                                </div>
                            </div>

                            {/* Selected Products Table */}
                            {selectedProductsForAdd.length > 0 && (
                                <div className="na-selected">
                                    <div className="na-selected-head">
                                        <span>Selected Products ({selectedProductsForAdd.length})</span>
                                        <button type="button" className="na-linkbtn is-danger" onClick={() => setSelectedProductsForAdd([])}>
                                            Clear all
                                        </button>
                                    </div>
                                    <div className="na-tablewrap">
                                        <table className="na-table na-table-sm">
                                            <thead>
                                                <tr>
                                                    <th style={{ width: 56 }}>#</th>
                                                    <th>Product Name</th>
                                                    <th style={{ width: 150 }}>Sequence</th>
                                                    <th style={{ width: 60 }} />
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {selectedProductsForAdd.map((product, index) => (
                                                    <tr key={product._id}>
                                                        <td><span className="na-seq">{index + 1}</span></td>
                                                        <td className="na-prod-name">{product.name}</td>
                                                        <td>
                                                            <Form.Control
                                                                type="number"
                                                                className="na-input na-input-sm"
                                                                value={product.sequenceNumber}
                                                                onChange={(e) => handleUpdateSequence(index, e.target.value)}
                                                                min="0.01"
                                                                step="0.01"
                                                            />
                                                        </td>
                                                        <td className="text-end">
                                                            <button type="button" className="na-ibtn is-danger" onClick={() => handleRemoveSelectedProduct(index)} title="Remove" aria-label="Remove">
                                                                <X size={14} />
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            )}
                        </Modal.Body>
                        <Modal.Footer>
                            <Button className="na-btn na-btn-soft" onClick={handleCloseAddModal} disabled={addLoading}>
                                Cancel
                            </Button>
                            <Button
                                className="na-btn na-btn-primary"
                                type="submit"
                                disabled={addLoading || selectedProductsForAdd.length === 0 || !addTargetOutlet}
                            >
                                {addLoading ? (
                                    <>
                                        <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                                        Adding...
                                    </>
                                ) : (
                                    `Add ${selectedProductsForAdd.length} Product${selectedProductsForAdd.length !== 1 ? 's' : ''}`
                                )}
                            </Button>
                        </Modal.Footer>
                    </Form>
                </Modal>
            </div>
        </>
    );
};

const naStyles = `
  .na-page { --na-primary:#3a57e8; --na-primary-dark:#2b44c4; --na-ink:#1d2939; --na-muted:#667085; --na-line:#e4e7ec; padding:18px 24px 40px; background:#f5f6fa; }
  .na-muted { color:var(--na-muted); }

  /* Banner */
  .na-banner { position:relative; display:flex; align-items:center; gap:16px; padding:22px 24px; border-radius:10px; margin-bottom:16px; overflow:hidden; color:#fff; background:linear-gradient(110deg,#0d1b4c 0%,#16296b 55%,#1f3a8a 100%); }
  .na-banner::after { content:""; position:absolute; inset:0; background:radial-gradient(circle at 80% 30%, rgba(255,170,90,.28), transparent 42%), radial-gradient(circle at 70% 80%, rgba(120,150,255,.25), transparent 45%); pointer-events:none; }
  .na-banner-left { position:relative; z-index:1; display:flex; align-items:center; gap:16px; flex:1; min-width:0; }
  .na-banner-icon { width:58px; height:58px; flex-shrink:0; border-radius:10px; display:flex; align-items:center; justify-content:center; color:#fff; background:linear-gradient(135deg,#3a57e8,#5b78ff); box-shadow:0 8px 20px rgba(58,87,232,.45); }
  .na-eyebrow { font-size:11px; letter-spacing:.14em; text-transform:uppercase; color:#b9c6ff; font-weight:600; margin-bottom:2px; }
  .na-title { font-weight:700; color:#fff; margin:0 0 2px; font-size:24px; letter-spacing:-.3px; }
  .na-subtitle { color:#d3dbff; font-size:13px; margin:0; }
  .na-banner-art { position:relative; z-index:1; width:190px; height:70px; flex-shrink:0; }
  .na-art-plate { position:absolute; right:20px; top:-26px; width:112px; height:112px; border-radius:50%; border:1px solid rgba(255,255,255,.25); background:radial-gradient(circle at 35% 30%, rgba(255,255,255,.28), rgba(255,255,255,.05)); display:flex; flex-direction:column; align-items:center; justify-content:center; gap:9px; }
  .na-art-plate span { height:6px; width:52%; border-radius:3px; background:rgba(255,214,170,.65); }
  .na-art-plate span:nth-child(2) { width:36%; background:rgba(200,214,255,.6); }
  .na-banner-actions { position:relative; z-index:1; display:flex; gap:10px; flex-shrink:0; }
  .na-spin { animation:na-rot 1s linear infinite; }
  @keyframes na-rot { to { transform:rotate(360deg); } }

  /* Buttons */
  .na-btn.btn { height:40px; padding:0 16px; font-size:13.5px; font-weight:600; border-radius:8px; display:inline-flex; align-items:center; justify-content:center; gap:7px; white-space:nowrap; }
  .na-btn-primary.btn { background:var(--na-primary); border-color:var(--na-primary); color:#fff; }
  .na-btn-primary.btn:hover, .na-btn-primary.btn:focus, .na-btn-primary.btn:active { background:var(--na-primary-dark) !important; border-color:var(--na-primary-dark) !important; color:#fff; }
  .na-btn-primary.btn:disabled { background:var(--na-primary); border-color:var(--na-primary); opacity:.55; }
  .na-btn-soft.btn { background:#f2f4f7; border-color:#f2f4f7; color:#344054; }
  .na-btn-soft.btn:hover { background:#e4e7ec; border-color:#e4e7ec; color:#1d2939; }
  .na-btn-soft.btn:disabled { opacity:.55; }
  .na-btn-success.btn { background:#fff; border:1px solid #a6e3c3; color:#0f8a4c; }
  .na-btn-success.btn:hover { background:#e6f7ee; border-color:#12b76a; color:#0f8a4c; }
  .na-btn-success.btn:disabled { opacity:.55; }
  .na-btn-danger.btn { background:#d92d20; border-color:#d92d20; color:#fff; }
  .na-btn-danger.btn:hover { background:#b42318; border-color:#b42318; color:#fff; }
  .na-btn-ghost.btn { color:#fff; background:rgba(255,255,255,.06); border:1px solid rgba(255,255,255,.4); }
  .na-btn-ghost.btn:hover, .na-btn-ghost.btn:focus { color:#fff; background:rgba(255,255,255,.16); border-color:rgba(255,255,255,.7); }
  .na-linkbtn { background:none; border:0; padding:0; font-size:12.5px; font-weight:600; color:var(--na-primary); cursor:pointer; }
  .na-linkbtn:hover { text-decoration:underline; }
  .na-linkbtn.is-danger { color:#d92d20; }

  /* Panels + filters */
  .na-panel { background:#fff; border:1px solid var(--na-line); border-radius:10px; padding:14px; margin-bottom:16px; }
  .na-filters { display:flex; flex-wrap:wrap; gap:12px; align-items:center; }
  .na-search { position:relative; flex:1 1 260px; min-width:220px; }
  .na-search-wide { flex:1 1 320px; }
  .na-search > svg { position:absolute; left:12px; top:50%; transform:translateY(-50%); color:#667085; }
  .na-search input { width:100%; height:40px; border:1px solid #d0d5dd; border-radius:8px; padding:0 32px 0 36px; font-size:13px; outline:none; background:#fff; }
  .na-search input:focus { border-color:var(--na-primary); box-shadow:0 0 0 3px rgba(58,87,232,.15); }
  .na-search button { position:absolute; right:6px; top:50%; transform:translateY(-50%); border:0; background:none; color:#98a2b3; padding:4px; display:flex; }
  .na-fsel { flex:0 1 180px; min-width:150px; }
  .na-date-wrap { position:relative; display:flex; align-items:center; }
  .na-date-icon { position:absolute; left:12px; color:#667085; pointer-events:none; z-index:1; }
  .na-date-input { width:250px; height:40px; font-size:13px; padding:0 30px 0 36px; border:1px solid #d0d5dd; border-radius:8px; color:#1d2939; background:#fff; }
  .na-date-input:focus { border-color:var(--na-primary); box-shadow:0 0 0 3px rgba(58,87,232,.15); outline:none; }
  .react-datepicker-popper { z-index:1060; }
  .na-date-clear { position:absolute; right:8px; background:none; border:0; color:#98a2b3; padding:4px; display:flex; }

  /* KPI cards */
  .na-kpis { display:grid; grid-template-columns:repeat(4,minmax(0,1fr)); gap:14px; margin-bottom:16px; }
  .na-kpi { display:flex; align-items:center; gap:14px; text-align:left; border:1px solid var(--na-line); border-radius:10px; padding:14px 16px; background:#fff; transition:box-shadow .15s, border-color .15s, transform .15s; }
  .na-kpi:hover { box-shadow:0 4px 14px rgba(16,24,40,.08); transform:translateY(-1px); }
  .na-kpi.is-active { border-color:var(--na-primary); box-shadow:0 0 0 1px var(--na-primary) inset; }
  .na-kpi-icon { width:44px; height:44px; flex-shrink:0; border-radius:10px; display:flex; align-items:center; justify-content:center; }
  .na-kpi-value { font-size:18px; font-weight:600; color:var(--na-ink); line-height:1.1; }
  .na-kpi-label { font-size:12.5px; color:var(--na-muted); margin-top:2px; }
  .na-kpi.tone-blue { background:linear-gradient(135deg,#fff 50%,#eaf1ff); } .tone-blue .na-kpi-icon { background:#e0e9ff; color:#3a57e8; }
  .na-kpi.tone-green { background:linear-gradient(135deg,#fff 50%,#e7f7ee); } .tone-green .na-kpi-icon { background:#d6f3e3; color:#0f9d58; }
  .na-kpi.tone-orange { background:linear-gradient(135deg,#fff 50%,#fff1e0); } .tone-orange .na-kpi-icon { background:#ffe6c7; color:#ea8a00; }
  .na-kpi.tone-red { background:linear-gradient(135deg,#fff 50%,#feeceb); } .tone-red .na-kpi-icon { background:#fddad7; color:#d92d20; }

  /* Outlet cards */
  .na-grid-panel { padding:16px; }
  .na-grid { display:grid; grid-template-columns:repeat(3,minmax(0,1fr)); gap:16px; }
  .na-card { background:#fff; border:1px solid var(--na-line); border-radius:10px; padding:14px; transition:box-shadow .15s, border-color .15s; }
  .na-card:hover { border-color:#c7d0e0; box-shadow:0 4px 14px rgba(16,24,40,.07); }
  .na-card-top { display:flex; gap:14px; align-items:flex-start; }
  .na-thumb { flex-shrink:0; border-radius:8px; overflow:hidden; background:linear-gradient(135deg,#e8eeff,#d5defc); display:flex; align-items:center; justify-content:center; color:var(--na-primary); font-weight:700; }
  .na-thumb img { width:100%; height:100%; object-fit:cover; }
  .na-card-info { flex:1; min-width:0; }
  .na-card-row { display:flex; align-items:center; gap:8px; }
  .na-card-name { flex:1; min-width:0; font-size:15px; font-weight:600; color:var(--na-ink); white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
  .na-card-loc { display:flex; align-items:center; gap:6px; margin-top:6px; font-size:12.5px; color:var(--na-muted); min-width:0; }
  .na-card-loc svg { color:var(--na-primary); flex-shrink:0; }
  .na-card-loc span { overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
  .na-pill { display:inline-flex; align-items:center; gap:6px; font-size:11.5px; font-weight:600; padding:2px 10px; border-radius:20px; flex-shrink:0; }
  .na-pill::before { content:""; width:6px; height:6px; border-radius:50%; background:currentColor; }
  .na-pill.is-active { background:#e6f7ee; color:#0f8a4c; }
  .na-pill.is-inactive { background:#fee4e2; color:#c4281c; }
  .na-pill.is-soon { background:#fff1d6; color:#b54708; }
  .na-pill.is-other { background:#f2f4f7; color:#667085; }

  .na-kebab { width:28px; height:28px; border:0; background:none; border-radius:6px; color:#475467; display:inline-flex; align-items:center; justify-content:center; flex-shrink:0; }
  .na-kebab:hover, .na-kebab[aria-expanded="true"] { background:#f2f4f7; color:var(--na-ink); }
  .na-kmenu { position:fixed; z-index:2000; background:#fff; border:1px solid var(--na-line); border-radius:8px; box-shadow:0 8px 24px rgba(16,24,40,.14); padding:4px 0; font-size:13px; }
  .na-kitem { display:flex; align-items:center; gap:9px; width:100%; padding:8px 14px; border:0; background:transparent; text-align:left; color:var(--na-ink); cursor:pointer; font-family:inherit; font-size:13px; }
  .na-kitem:hover, .na-kitem:focus { background:#f3f5fa; outline:none; }
  .na-kitem.is-danger { color:#d92d20; }

  .na-card-stats { display:flex; gap:10px; margin-top:12px; background:#f6f7fb; border-radius:8px; padding:10px 12px; }
  .na-stat { flex:1; display:flex; align-items:flex-start; gap:8px; min-width:0; }
  .na-stat > svg { color:var(--na-primary); margin-top:2px; flex-shrink:0; }
  .na-stat-label { font-size:11px; color:var(--na-muted); }
  .na-stat-value { font-size:11px; font-weight:600; color:var(--na-ink); line-height:1.25; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
  .na-dots { color:#98a2b3; letter-spacing:2px; }
  .na-card-btn { width:100%; display:flex; align-items:center; gap:4px; margin-top:10px; border:0; background:#f6f7fb; border-radius:8px; padding:9px 12px; font-size:12.5px; font-weight:600; color:var(--na-primary); text-align:left; }
  .na-card-btn:hover { background:var(--na-primary); color:#fff; }

  .na-empty { text-align:center; color:var(--na-muted); padding:40px 0; font-size:13.5px; }
  .na-empty-icon { width:54px; height:54px; margin:0 auto 12px; border-radius:12px; background:#eef2ff; color:var(--na-primary); display:flex; align-items:center; justify-content:center; }
  .na-empty-title { font-size:16px; font-weight:600; color:var(--na-ink); margin-bottom:4px; }

  .na-pagination { display:flex; justify-content:space-between; align-items:center; gap:12px; flex-wrap:wrap; margin-top:16px; }
  .na-pagination-info { font-size:13px; color:var(--na-muted); }
  .na-pagination-controls { display:flex; align-items:center; gap:6px; }
  .na-pg { min-width:34px; height:34px; padding:0 8px; border:1px solid var(--na-line); background:#fff; border-radius:8px; font-size:13px; font-weight:600; color:#344054; display:inline-flex; align-items:center; justify-content:center; }
  .na-pg:hover:not(:disabled) { border-color:var(--na-primary); color:var(--na-primary); }
  .na-pg.is-on { background:var(--na-primary); border-color:var(--na-primary); color:#fff; }
  .na-pg:disabled { opacity:.5; cursor:not-allowed; }
  .na-pg-gap { color:#98a2b3; padding:0 4px; }
  .na-pagesize.form-select { width:112px; height:34px; font-size:13px; border-radius:8px; margin-left:6px; border-color:var(--na-line); }

  /* Products view */
  .na-outlet-head { display:flex; align-items:center; gap:16px; }
  .na-outlet-head-info { flex:1; min-width:0; }
  .na-outlet-name { margin:0; font-size:18px; font-weight:700; color:var(--na-ink); }
  .na-total { text-align:center; padding:8px 22px; border-radius:10px; background:linear-gradient(135deg,#3a57e8,#5b78ff); color:#fff; }
  .na-total-value { font-size:26px; font-weight:700; line-height:1.1; }
  .na-total-label { font-size:11.5px; opacity:.9; }
  .na-table-panel { padding:6px; }
  .na-tablewrap { overflow-x:auto; transition:opacity .15s; }
  .na-tablewrap.is-loading { opacity:.55; pointer-events:none; }
  .na-table { width:100%; border-collapse:collapse; min-width:640px; }
  .na-table thead th { font-size:11px; text-transform:uppercase; letter-spacing:.05em; color:#667085; font-weight:600; padding:14px 12px; border-bottom:1px solid var(--na-line); white-space:nowrap; }
  .na-table td { padding:12px; font-size:13px; color:#344054; border-bottom:1px solid #f0f2f5; vertical-align:middle; }
  .na-table tbody tr:last-child td { border-bottom:0; }
  .na-table tbody tr:hover { background:#fafbff; }
  .na-table-sm thead th { padding:10px 12px; }
  .na-table-sm td { padding:8px 12px; }
  .na-seq { display:inline-flex; align-items:center; justify-content:center; min-width:30px; height:26px; padding:0 8px; border-radius:6px; background:#eef2ff; color:var(--na-primary); font-weight:700; font-size:12.5px; }
  .na-prod-name { font-weight:600; color:var(--na-ink); }
  .na-sub { font-size:11.5px; color:#98a2b3; }
  .na-food { display:inline-block; font-size:11px; font-weight:700; padding:2px 9px; border-radius:20px; background:#f2f4f7; color:#475467; }
  .na-food.is-veg, .na-food.is-vegan { background:#e6f7ee; color:#0f8a4c; }
  .na-food.is-nonveg { background:#fee4e2; color:#c4281c; }
  .na-ibtns { display:inline-flex; gap:2px; }
  .na-ibtn { width:32px; height:32px; border:0; background:none; border-radius:6px; color:#667085; display:inline-flex; align-items:center; justify-content:center; }
  .na-ibtn:hover { background:#eef2ff; color:var(--na-primary); }
  .na-ibtn.is-danger:hover { background:#fee4e2; color:#d92d20; }

  /* Modals */
  .na-modal .modal-content { border:0; border-radius:12px; box-shadow:0 20px 50px rgba(16,24,40,.25); }
  .na-modal .modal-header { align-items:center; gap:12px; padding:16px 20px; border-bottom:1px solid var(--na-line); }
  .na-modal .modal-header .btn-close { margin:0 0 0 auto; }
  .na-mh-icon { width:40px; height:40px; border-radius:10px; background:#e8eeff; color:var(--na-primary); display:flex; align-items:center; justify-content:center; flex-shrink:0; }
  .na-modal-title { font-size:16px; font-weight:700; color:var(--na-ink); }
  .na-modal-sub { font-size:12.5px; color:var(--na-muted); margin-top:1px; }
  .na-modal .modal-body { padding:18px 20px; }
  .na-modal .modal-footer { gap:8px; padding:12px 20px; border-top:1px solid var(--na-line); background:#fafbfc; border-radius:0 0 12px 12px; }
  .na-label { display:block; font-size:12.5px; font-weight:600; color:#344054; margin-bottom:5px; }
  .na-req { color:#d92d20; }
  .na-input.form-control { height:40px; font-size:14px; border-radius:8px; border-color:#d0d5dd; }
  .na-input.form-control:focus { border-color:var(--na-primary); box-shadow:0 0 0 3px rgba(58,87,232,.15); }
  .na-input-sm.form-control { height:34px; font-size:13px; }
  .na-add-grid { display:grid; grid-template-columns:minmax(0,1fr) minmax(0,1.6fr); gap:14px; }
  .na-selected { margin-top:16px; border:1px solid var(--na-line); border-radius:10px; overflow:hidden; }
  .na-selected-head { display:flex; justify-content:space-between; align-items:center; padding:10px 14px; background:#fafbfc; border-bottom:1px solid var(--na-line); font-size:12.5px; font-weight:700; color:#344054; }
  .na-selected .na-table { min-width:0; }
  .na-del-body { padding:24px 22px 20px; }
  .na-del-icon { width:46px; height:46px; margin:0 auto 12px; border-radius:50%; background:#fee4e2; color:#d92d20; display:flex; align-items:center; justify-content:center; }
  .na-del-box { background:#fffaeb; border:1px solid #fedf89; border-radius:8px; padding:10px 12px; font-size:13px; text-align:left; margin:10px 0; color:#7a2e0e; }
  .na-del-text { font-size:12.5px; color:var(--na-muted); margin:0 0 16px; }

  @media (max-width: 1399px) { .na-grid { grid-template-columns:repeat(2,minmax(0,1fr)); } }
  @media (max-width: 1199px) { .na-banner-art { display:none; } .na-kpis { grid-template-columns:repeat(2,minmax(0,1fr)); } }
  @media (max-width: 991px) { .na-page { padding:14px 12px 32px; } .na-add-grid { grid-template-columns:1fr; } }
  @media (max-width: 767px) {
    .na-grid { grid-template-columns:1fr; }
    .na-banner { flex-wrap:wrap; }
    .na-fsel { flex:1 1 100%; }
    .na-date-input, .na-date-wrap, .na-date-wrap .react-datepicker-wrapper { width:100%; }
    .na-outlet-head { flex-wrap:wrap; }
    .na-pagination { justify-content:center; }
  }
  @media (max-width: 575px) { .na-kpis { grid-template-columns:1fr; } }
`;

export default NewArrivals;